function normalizeHtml(htmlString) {
	const parser = new DOMParser();
	const doc = parser.parseFromString(htmlString, "text/html");
	return doc.body.innerHTML;
}

const checkIcon = `<span class="race-check-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="10" height="10" fill="none" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1.5,5.5 4,8 8.5,2.5"></polyline></svg></span>`;

const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.85 14.85" width="20" height="20" aria-hidden="true">
	<g>
		<path d="M6.72 7.42L0 14.14l.71.71 6.71-6.72 6.72 6.72.71-.71-6.72-6.72L14.85.71 14.14 0 7.42 6.72.71 0 0 .71z"
			fill="#000000" fill-rule="evenodd" />
	</g>
</svg>`;

const editIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
	<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
	<path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
</svg>`;

const deleteIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
	<polyline points="3 6 5 6 21 6"></polyline>
	<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
	<line x1="10" y1="11" x2="10" y2="17"></line>
	<line x1="14" y1="11" x2="14" y2="17"></line>
</svg>`;

const chevronIcon = `<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M3.5 5.5 7 9l3.5-3.5" stroke="currentColor" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

const chevronRightIcon = `<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M5 3l4 4-4 4" stroke="currentColor" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

const successCheckIcon = `<svg viewBox="0 0 12 10" fill="none" aria-hidden="true"><path d="M1 5l3.5 3.5L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

const redeemedCheckIcon = `<svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true"><path d="M6.66667 2L3 5.66667L1.33333 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

const closeXIcon = `<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>`;

function escapeHtml(value) {
	return String(value == null ? "" : value)
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;");
}

function prefersReducedMotion() {
	return (
		typeof window.matchMedia === "function" &&
		window.matchMedia("(prefers-reduced-motion: reduce)").matches
	);
}

document.addEventListener("DOMContentLoaded", function () {
	const dashboardContainer = document.querySelector(".membership-dashboard");
	if (!dashboardContainer) return;

	// Get API configuration from data attributes
	const config = {
		apiUrl: dashboardContainer.getAttribute("data-api-url"),
		memberId: dashboardContainer.getAttribute("data-member-id"),
		apiUrlMember: dashboardContainer.getAttribute("data-api-url-member"),
		signature: dashboardContainer.getAttribute("data-signature"),
	};

	// Initialize consent modal only if enabled in settings
	const consentConfigScript = document.getElementById("consent-config");
	let consentEnabled = false;

	if (consentConfigScript) {
		try {
			const configData = JSON.parse(consentConfigScript.textContent);
			consentEnabled = configData.enabled || false;
		} catch (e) {
			console.warn("Could not parse consent config JSON");
		}
	}

	if (consentEnabled) {
		initConsentModal();
	}

	// Initialize dashboard
	initializeDashboard(config);
	initializeFilters();
	initAddRaceModal();
	initBenefitsUsed();
	initSavingsScope(config);
	initTooltips();
	initViewTabs();
	initCategoryPills();
	initBenefitsPagination();
	renderCustomerRaces();
	initRaceCountdownTicker();
	novelPassLinksReplace();
	initRedeemModal();
	initHeaderTooltips();
	initNotificationCenter();
	initWalletModal();
});

function pinRevealRows(reveal, value) {
	reveal.style.transition = "none";
	reveal.style.gridTemplateRows = value;
	reveal.getBoundingClientRect();
	reveal.style.transition = "";
}

function applyRevealState(reveal, open) {
	reveal.setAttribute("data-open", open ? "true" : "false");
	pinRevealRows(reveal, "");
	return reveal.getBoundingClientRect().height;
}

function findRevealTransition(reveal) {
	return reveal
		.getAnimations()
		.find((animation) => animation.transitionProperty === "grid-template-rows");
}

function setRevealOpen(reveal, open) {
	if (!reveal) return;

	const startHeight = reveal.getBoundingClientRect().height;
	const targetHeight = applyRevealState(reveal, open);

	pinRevealRows(reveal, `${startHeight}px`);
	reveal.style.gridTemplateRows = `${targetHeight}px`;

	const transition = findRevealTransition(reveal);
	if (!transition) {
		pinRevealRows(reveal, "");
		return;
	}

	const settle = () => {
		if (findRevealTransition(reveal)) return;
		pinRevealRows(reveal, "");
	};
	transition.finished.then(settle, settle);
}

function initRevealToggles(root) {
	const scope = root || document;
	scope.querySelectorAll(".js-md-reveal-toggle").forEach((toggle) => {
		if (toggle.dataset.revealBound === "true") return;
		toggle.dataset.revealBound = "true";

		toggle.addEventListener("click", (e) => {
			e.preventDefault();
			const targetId = toggle.getAttribute("aria-controls");
			const target = targetId ? document.getElementById(targetId) : null;
			const isOpen = toggle.getAttribute("aria-expanded") === "true";

			toggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
			setRevealOpen(target, !isOpen);
		});
	});
}

function initViewTabs() {
	const tabs = Array.from(document.querySelectorAll(".js-md-view-tab"));
	if (!tabs.length) return;

	const panels = Array.from(document.querySelectorAll(".md-view"));

	const activate = (view, persist) => {
		tabs.forEach((tab) => {
			const isActive = tab.dataset.view === view;
			tab.classList.toggle("is-active", isActive);
			tab.setAttribute("aria-selected", isActive ? "true" : "false");
		});
		panels.forEach((panel) => {
			panel.hidden = panel.dataset.view !== view;
		});
		if (persist) {
			try {
				sessionStorage.setItem("bandit-view", view);
			} catch {
				// sessionStorage can be unavailable (private mode) — ignore.
			}
		}
	};

	tabs.forEach((tab) => {
		tab.addEventListener("click", (e) => {
			e.preventDefault();
			activate(tab.dataset.view, true);
		});
	});

	// A ?tab= link (e.g. the old /pages/referrals-dashboard redirect) wins over
	// the tab remembered for this session.
	let stored = new URLSearchParams(window.location.search).get("tab");
	if (!stored) {
		try {
			stored = sessionStorage.getItem("bandit-view");
		} catch {
			stored = null;
		}
	}
	const known = tabs.some((tab) => tab.dataset.view === stored);
	activate(known ? stored : "benefits", false);
}

/**
 * Replace novelpass link
 */
function updateNovelPassLinks(href) {
	document
		.querySelectorAll('[data-type="membership-card"]')
		.forEach((i) => (i.href = href));
}

let noverlPassLinksObserver = null;

function novelPassLinksReplace() {
	const rootLink = document.getElementById("rootNovelPassLink");
	if (rootLink) {
		updateNovelPassLinks(rootLink.href);

		if (noverlPassLinksObserver) {
			return;
		}

		noverlPassLinksObserver = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (
					mutation.type === "attributes" &&
					mutation.attributeName === "href"
				) {
					updateNovelPassLinks(rootLink.href);
				}
			});
		});

		noverlPassLinksObserver.observe(rootLink, {
			attributes: true,
			attributeFilter: ["href"],
		});
	}
}

function initHeaderTooltips() {
	document.querySelectorAll(".js-md-tooltip").forEach((wrap) => {
		const bubble = wrap.querySelector(".md-tooltip");
		const trigger = wrap.querySelector("button, a");
		if (!bubble || !trigger || !bubble.id) return;

		let timer = null;

		const show = () => {
			clearTimeout(timer);
			timer = setTimeout(
				() => {
					bubble.classList.add("is-visible");
					trigger.setAttribute("aria-describedby", bubble.id);
				},
				prefersReducedMotion() ? 0 : 300
			);
		};

		const hide = () => {
			clearTimeout(timer);
			bubble.classList.remove("is-visible");
			trigger.removeAttribute("aria-describedby");
		};

		wrap.addEventListener("mouseenter", show);
		wrap.addEventListener("mouseleave", hide);
		wrap.addEventListener("focusin", show);
		wrap.addEventListener("focusout", hide);
		wrap.addEventListener("keydown", (e) => {
			if (e.key === "Escape") hide();
		});
		// Touch devices: the tooltip would sit on top of the tray/modal.
		wrap.addEventListener("touchstart", hide, { passive: true });
	});
}

const NOTIFICATION_COPY = {
	personalization: {
		// Fallback for a blank Membership Personalization Message setting, as the old banner had.
		title: "Complete your membership personalization",
	},
	renewal: {
		titleTemplate: "Welcome to The Bandit Membership Year {year}",
		title: "Claim your free Member Socks",
		sub: "",
		groupLabel: "Select your size:",
		successLabel: "Size saved — thanks!",
	},
	upcomingRenewal: {
		title: "Your Upcoming Renewal",
		sub: "Renewing soon · review your membership",
		actionLabel: "Cancel Membership",
	},
};

const NOTIFICATION_KEYS = ["personalization", "renewal", "upcomingRenewal"];

const NOTIFICATION_FOCUSABLE = 'button:not(:disabled), [role="radio"], a[href]';

function getNotificationsConfig() {
	const configScript = document.getElementById("notifications-config");
	if (!configScript) return {};

	try {
		return JSON.parse(configScript.textContent) || {};
	} catch (e) {
		console.warn("Could not parse notifications config JSON");
		return {};
	}
}

function normaliseNotificationState(config) {
	const merged = {};

	NOTIFICATION_KEYS.forEach((key) => {
		merged[key] = Object.assign({}, (config && config[key]) || {});
	});

	return merged;
}

function evaluateNotificationItems(config, dynamic) {
	const state = normaliseNotificationState(
		Object.assign({}, config, dynamic || {})
	);
	const items = [];

	if (state.personalization.enabled && state.personalization.href) {
		items.push({
			id: "personalization",
			type: "link",
			href: state.personalization.href,
			newTab: true,
			title:
				state.personalization.message ||
				NOTIFICATION_COPY.personalization.title,
		});
	}

	const renewalOptions = Array.isArray(state.renewal.options)
		? state.renewal.options.filter(
				(option) => option && option.label && option.url
			)
		: [];

	if (state.renewal.enabled && renewalOptions.length) {
		const renewalYear = parseInt(state.renewal.yearCount, 10);
		items.push({
			id: "renewal",
			type: "picker",
			options: renewalOptions,
			letter:
				typeof state.renewal.letter === "string" ? state.renewal.letter : "",
			title: renewalYear
				? NOTIFICATION_COPY.renewal.titleTemplate.replace("{year}", renewalYear)
				: NOTIFICATION_COPY.renewal.title,
			sub: NOTIFICATION_COPY.renewal.sub,
		});
	}

	if (state.upcomingRenewal.enabled && state.upcomingRenewal.href) {
		items.push({
			id: "upcomingRenewal",
			type: "link",
			href: state.upcomingRenewal.href,
			newTab: false,
			title:
				state.upcomingRenewal.title || NOTIFICATION_COPY.upcomingRenewal.title,
			sub: state.upcomingRenewal.sub || NOTIFICATION_COPY.upcomingRenewal.sub,
			actionLabel: NOTIFICATION_COPY.upcomingRenewal.actionLabel,
		});
	}

	return items;
}

function initNotificationCenter() {
	const wrap = document.querySelector(".js-notifications");
	const bell = wrap ? wrap.querySelector(".js-notifications-toggle") : null;
	const tray = document.getElementById("md-notifications-tray");
	if (!wrap || !bell || !tray) return;

	const list = tray.querySelector(".js-notifications-list");
	const emptyState = tray.querySelector(".js-notifications-empty");
	const badge = bell.querySelector(".js-notifications-badge");
	const config = getNotificationsConfig();
	const dynamic = {};
	const dismissed = new Set();

	let items = [];
	let isOpen = false;
	let expandedId = null;
	let selectedLabel = null;
	try {
		selectedLabel = sessionStorage.getItem("bandit-sock-size");
	} catch {
		selectedLabel = null;
	}

	function itemMarkup(item, index) {
		const divided = index > 0 ? " md-tray__item--divided" : "";
		const subMarkup = item.sub
			? `\n					<span class="md-tray__sub">${escapeHtml(item.sub)}</span>`
			: "";
		const actionMarkup = item.actionLabel
			? `\n					<span class="md-tray__action">${escapeHtml(item.actionLabel)}</span>`
			: "";
		const text = `
				<span class="md-tray__text">
					<span class="md-tray__title">${escapeHtml(item.title)}</span>${subMarkup}${actionMarkup}
				</span>`;

		if (item.type === "picker") {
			const pickerId = `md-notification-picker-${item.id}`;
			const groupLabelId = `${pickerId}-label`;
			const options = item.options
				.map(
					(option, i) => `
								<span
									class="md-tray__size"
									role="radio"
									aria-checked="false"
									tabindex="${i === 0 ? "0" : "-1"}"
									data-option-index="${i}"
								>${escapeHtml(option.label)}</span>`
				)
				.join("");

			// Merchant richtext from the Membership Renewal Letter setting — inserted raw, as the on-page block did.
			const letterMarkup = item.letter
				? `
								<div class="md-tray__letter">${item.letter}</div>`
				: "";
			// The letter closes with its own "Select your Member Socks size:" line, so the visible label would duplicate it.
			const groupLabelMarkup = item.letter
				? ""
				: `
								<p class="md-tray__picker-label" id="${groupLabelId}">${escapeHtml(NOTIFICATION_COPY.renewal.groupLabel)}</p>`;
			const sizesLabelAttribute = item.letter
				? `aria-label="${escapeHtml(NOTIFICATION_COPY.renewal.groupLabel)}"`
				: `aria-labelledby="${groupLabelId}"`;

			return `
			<div class="md-tray__item md-tray__item--picker${divided}" role="none" data-notification-id="${escapeHtml(item.id)}">
				<button
					type="button"
					role="menuitem"
					class="md-tray__row js-notification-expand"
					aria-expanded="false"
					aria-controls="${pickerId}"
				>
					${text}
					<span class="md-tray__chev" aria-hidden="true">${chevronRightIcon}</span>
				</button>
				<div class="md-reveal md-tray__picker" id="${pickerId}" data-open="false">
					<div class="md-reveal__clip">
						<div class="md-reveal__inner">
							<div class="md-tray__picker-body">${letterMarkup}${groupLabelMarkup}
								<div class="md-tray__sizes" role="radiogroup" ${sizesLabelAttribute}>${options}
								</div>
							</div>
							<div class="md-tray__success" hidden>
								<span class="md-tray__success-icon" aria-hidden="true">${successCheckIcon}</span>
								<span class="md-tray__success-text">${escapeHtml(NOTIFICATION_COPY.renewal.successLabel)}</span>
							</div>
						</div>
					</div>
				</div>
			</div>`;
		}

		return `
			<button
				type="button"
				role="menuitem"
				class="md-tray__item md-tray__row js-notification-link${divided}"
				data-notification-id="${escapeHtml(item.id)}"
			>
				${text}
				<span class="md-tray__chev" aria-hidden="true">${chevronRightIcon}</span>
			</button>`;
	}

	function updateBadge() {
		const count = items.length;

		if (badge) {
			badge.hidden = count === 0;
			badge.textContent = count > 9 ? "9+" : String(count);
			badge.setAttribute(
				"aria-label",
				`${count} notification${count === 1 ? "" : "s"}`
			);
		}

		bell.setAttribute(
			"aria-label",
			count > 0 ? `Notifications, ${count} new` : "Notifications"
		);
	}

	function getItem(id) {
		return items.find((item) => item.id === id) || null;
	}

	function setSelectedLabel(container, label) {
		selectedLabel = label;
		const radios = Array.from(container.querySelectorAll('[role="radio"]'));
		let hasSelection = false;

		radios.forEach((radio) => {
			const isChecked = radio.textContent.trim() === label;
			if (isChecked) hasSelection = true;
			radio.setAttribute("aria-checked", isChecked ? "true" : "false");
			radio.classList.toggle("is-selected", isChecked);
		});

		radios.forEach((radio, i) => {
			const isChecked = radio.getAttribute("aria-checked") === "true";
			radio.tabIndex = isChecked || (!hasSelection && i === 0) ? 0 : -1;
		});

		if (!hasSelection) selectedLabel = null;
	}

	/** Roving focus only — picking a size commits it, so arrow keys must not select. */
	function focusOption(container, radio) {
		container.querySelectorAll('[role="radio"]').forEach((option) => {
			option.tabIndex = option === radio ? 0 : -1;
		});
		radio.focus();
	}

	function setExpanded(container, expanded) {
		const toggle = container.querySelector(".js-notification-expand");
		const picker = container.querySelector(".md-tray__picker");
		if (!toggle || !picker) return;

		toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
		setRevealOpen(picker, expanded);
		expandedId = expanded
			? container.getAttribute("data-notification-id")
			: null;
	}

	function collapseAll() {
		list
			.querySelectorAll(".md-tray__item--picker")
			.forEach((container) => setExpanded(container, false));
		expandedId = null;
	}

	function render() {
		const wasExpanded = expandedId;

		list.innerHTML = items
			.map((item, index) => itemMarkup(item, index))
			.join("");
		if (emptyState) emptyState.hidden = items.length > 0;

		list.querySelectorAll(".md-tray__item--picker").forEach((container) => {
			setSelectedLabel(container, selectedLabel);
			if (container.getAttribute("data-notification-id") === wasExpanded) {
				setExpanded(container, true);
			}
		});

		updateBadge();
	}

	function refresh() {
		items = evaluateNotificationItems(config, dynamic).filter(
			(item) => !dismissed.has(item.id)
		);
		render();
	}

	function completeItem(id) {
		dismissed.add(id);
		refresh();

		if (!items.length && isOpen) {
			setTimeout(() => close(true), 350);
		}
	}

	function focusables() {
		return Array.from(tray.querySelectorAll(NOTIFICATION_FOCUSABLE)).filter(
			(el) =>
				el.offsetParent !== null &&
				el.tabIndex !== -1 &&
				!el.closest('.md-reveal[data-open="false"]')
		);
	}

	function handleOutside(e) {
		if (!wrap.contains(e.target)) close(false);
	}

	function handleKeydown(e) {
		if (e.key === "Escape") {
			e.preventDefault();
			close(true);
			return;
		}

		if (e.key !== "Tab") return;

		const els = focusables();
		if (!els.length) return;

		const first = els[0];
		const last = els[els.length - 1];

		if (e.shiftKey && document.activeElement === first) {
			e.preventDefault();
			last.focus();
		} else if (!e.shiftKey && document.activeElement === last) {
			e.preventDefault();
			first.focus();
		}
	}

	function open() {
		if (isOpen) return;
		isOpen = true;
		tray.setAttribute("data-open", "true");
		tray.setAttribute("aria-hidden", "false");
		bell.setAttribute("aria-expanded", "true");
		wrap.classList.add("is-open");
		document.addEventListener("mousedown", handleOutside);
		document.addEventListener("keydown", handleKeydown);

		// The tray is visibility:hidden until the style applies — focus on the next tick.
		setTimeout(() => {
			if (!isOpen) return;
			const first = focusables()[0];
			if (first) first.focus();
		}, 20);
	}

	function close(refocus) {
		if (!isOpen) return;
		isOpen = false;
		tray.setAttribute("data-open", "false");
		tray.setAttribute("aria-hidden", "true");
		bell.setAttribute("aria-expanded", "false");
		wrap.classList.remove("is-open");
		document.removeEventListener("mousedown", handleOutside);
		document.removeEventListener("keydown", handleKeydown);
		collapseAll();

		if (refocus) bell.focus();
	}

	function activateLink(item) {
		if (!item || !item.href) return;

		// In-page anchors are placeholders — dismiss instead of navigating.
		if (item.href.charAt(0) === "#") {
			completeItem(item.id);
			close(true);
			return;
		}

		if (item.newTab) {
			window.open(item.href, "_blank", "noopener,noreferrer");
			close(true);
			return;
		}

		close(false);
		window.location.assign(item.href);
	}

	/** Picking a size is the commit: it sends the member to the cart with that variant. */
	function chooseSize(container, item, label) {
		const option = item.options.find((entry) => entry.label === label);
		if (!option) return;

		setSelectedLabel(container, label);

		try {
			sessionStorage.setItem("bandit-sock-size", option.label);
		} catch {
			// sessionStorage can be unavailable (private mode) — ignore.
		}

		const body = container.querySelector(".md-tray__picker-body");
		const success = container.querySelector(".md-tray__success");
		if (body) body.hidden = true;
		if (success) success.hidden = false;

		setTimeout(() => {
			completeItem(item.id);
			if (option.url.charAt(0) !== "#") window.location.assign(option.url);
		}, 400);
	}

	bell.addEventListener("click", (e) => {
		e.preventDefault();
		if (isOpen) {
			close(false);
		} else {
			open();
		}
	});

	list.addEventListener("click", (e) => {
		const radio = e.target.closest('[role="radio"]');
		if (radio) {
			const container = radio.closest(".md-tray__item--picker");
			const item = container && getItem(container.dataset.notificationId);
			if (container && item) {
				chooseSize(container, item, radio.textContent.trim());
			}
			return;
		}

		const expandBtn = e.target.closest(".js-notification-expand");
		if (expandBtn) {
			const container = expandBtn.closest(".md-tray__item--picker");
			if (!container) return;
			const expanded = expandBtn.getAttribute("aria-expanded") === "true";
			setExpanded(container, !expanded);
			if (!expanded) {
				const radios = container.querySelectorAll('[role="radio"]');
				const target =
					container.querySelector('[role="radio"][tabindex="0"]') || radios[0];
				if (target) target.focus();
			}
			return;
		}

		const linkBtn = e.target.closest(".js-notification-link");
		if (linkBtn) activateLink(getItem(linkBtn.dataset.notificationId));
	});

	list.addEventListener("keydown", (e) => {
		const radio = e.target.closest('[role="radio"]');
		if (!radio) return;

		const container = radio.closest(".md-tray__item--picker");
		if (!container) return;

		if (e.key === " " || e.key === "Enter") {
			e.preventDefault();
			const item = getItem(container.dataset.notificationId);
			if (item) chooseSize(container, item, radio.textContent.trim());
			return;
		}

		const forward = e.key === "ArrowRight" || e.key === "ArrowDown";
		const backward = e.key === "ArrowLeft" || e.key === "ArrowUp";
		if (!forward && !backward) return;

		e.preventDefault();
		const radios = Array.from(container.querySelectorAll('[role="radio"]'));
		const current = radios.indexOf(radio);
		const next = (current + (forward ? 1 : -1) + radios.length) % radios.length;
		focusOption(container, radios[next]);
	});

	function ingestUpcomingRenewal(detail) {
		if (!detail || !detail.href) return;

		const message =
			typeof detail.message === "string" ? detail.message.trim() : "";

		dynamic.upcomingRenewal = {
			enabled: true,
			href: detail.href,
			title: detail.title,
			sub: detail.sub || message,
		};
		refresh();
	}

	document.addEventListener("bandit:upcoming-renewal", (e) =>
		ingestUpcomingRenewal(e.detail)
	);
	// Replay: the Recharge lookup may resolve before this initialiser runs.
	ingestUpcomingRenewal(window.banditUpcomingRenewal);

	refresh();
}

const WALLET_MODAL_COPY = {
	explainerTitle: "Download your Wallet Pass",
	explainerLede:
		"Your Bandit Wallet Pass stores all your Bandit Credits. Add it to Apple Wallet or Google Wallet for quick access to your credits and for easy shopping in-store.",
	steps: [
		'Tap "Add to Wallet" below',
		"On the next page, tap Add to Apple Wallet or Google Wallet and approve the prompt.",
		"Your membership Wallet Pass appears in your phone wallet. Open it anytime to access your gift card and credits.",
	],
	blogStepPrefix: "For more info check out our blog post ",
	blogStepLinkLabel: "here",
	addLabel: "Add to Wallet",
	cancelLabel: "Cancel",
	confirmationTitle: "Opening your Novel pass…",
	confirmationLede:
		"Complete the steps in the new tab to finish adding your card.",
	blockedText: "The tab was blocked by your browser. Open your pass manually:",
	blockedLinkLabel: "Open your Novel pass →",
	retryLabel: "Didn't open? Open pass again",
	doneLabel: "Done",
};

/** Never hardcode a Novel domain here — novelPassLinksReplace() keeps the href in sync. */
function initWalletModal() {
	const trigger = document.getElementById("js-wallet-trigger");
	if (!trigger) return;

	const media = trigger.querySelector(".md-wallet-trigger__media");
	const iconMarkup = media ? media.innerHTML : "";
	const blogUrl = trigger.getAttribute("data-blog-url") || "";
	const stepHTML = WALLET_MODAL_COPY.steps.map(escapeHtml);
	if (blogUrl) {
		stepHTML.push(
			`${escapeHtml(WALLET_MODAL_COPY.blogStepPrefix)}<a class="md-wallet-modal__step-link" href="${escapeHtml(blogUrl)}" target="_blank" rel="noopener">${escapeHtml(WALLET_MODAL_COPY.blogStepLinkLabel)}</a>.`
		);
	}
	const steps = stepHTML
		.map(
			(html, i) => `
					<li class="md-wallet-modal__step-item">
						<span class="md-wallet-modal__step-num" aria-hidden="true">${i + 1}</span>
						<p class="md-wallet-modal__step-text">${html}</p>
					</li>`
		)
		.join("");

	const modalHTML = `
    <div class="md-wallet-modal" id="md-wallet-modal" hidden>
      <div class="md-wallet-modal__backdrop js-wallet-backdrop"></div>
      <div class="md-wallet-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="md-wallet-modal-title">
        <button type="button" class="md-wallet-modal__close js-wallet-close" aria-label="Close">${closeXIcon}</button>
        <div class="md-wallet-modal__body">
          <span class="md-wallet-modal__icon" aria-hidden="true">${iconMarkup}</span>

          <div class="md-wallet-modal__view" data-wallet-step="explainer">
            <h2 class="md-wallet-modal__title" id="md-wallet-modal-title">${escapeHtml(WALLET_MODAL_COPY.explainerTitle)}</h2>
            <p class="md-wallet-modal__lede">${escapeHtml(WALLET_MODAL_COPY.explainerLede)}</p>
            <ol class="md-wallet-modal__steps">${steps}
            </ol>
            <div class="md-wallet-modal__actions">
              <button type="button" class="md-wallet-modal__primary js-wallet-add">${escapeHtml(WALLET_MODAL_COPY.addLabel)}</button>
              <button type="button" class="md-wallet-modal__text-btn js-wallet-close">${escapeHtml(WALLET_MODAL_COPY.cancelLabel)}</button>
            </div>
          </div>

          <div class="md-wallet-modal__view" data-wallet-step="confirmation" hidden>
            <h2 class="md-wallet-modal__title" id="md-wallet-modal-title-confirmation">${escapeHtml(WALLET_MODAL_COPY.confirmationTitle)}</h2>
            <p class="md-wallet-modal__lede">${escapeHtml(WALLET_MODAL_COPY.confirmationLede)}</p>
            <div class="md-wallet-modal__fallback js-wallet-fallback" hidden>
              <p class="md-wallet-modal__fallback-text">${escapeHtml(WALLET_MODAL_COPY.blockedText)}</p>
              <a class="md-wallet-modal__fallback-link js-wallet-fallback-link" href="#" target="_blank" rel="noopener noreferrer">${escapeHtml(WALLET_MODAL_COPY.blockedLinkLabel)}</a>
            </div>
            <p class="md-wallet-modal__retry js-wallet-retry">
              <button type="button" class="md-wallet-modal__retry-btn js-wallet-retry-btn">${escapeHtml(WALLET_MODAL_COPY.retryLabel)}</button>
            </p>
            <div class="md-wallet-modal__actions">
              <button type="button" class="md-wallet-modal__primary js-wallet-close">${escapeHtml(WALLET_MODAL_COPY.doneLabel)}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

	if (!document.getElementById("md-wallet-modal")) {
		document.body.insertAdjacentHTML("beforeend", modalHTML);
	}

	const modal = document.getElementById("md-wallet-modal");
	if (!modal) return;

	const dialog = modal.querySelector(".md-wallet-modal__dialog");
	const views = Array.from(modal.querySelectorAll(".md-wallet-modal__view"));
	const fallback = modal.querySelector(".js-wallet-fallback");
	const fallbackLink = modal.querySelector(".js-wallet-fallback-link");
	const retry = modal.querySelector(".js-wallet-retry");

	let step = "explainer";
	let closeTimer = null;

	function focusables() {
		return Array.from(
			modal.querySelectorAll(
				'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
			)
		).filter((el) => el.offsetParent !== null);
	}

	function setStep(next, popupBlocked) {
		step = next;
		views.forEach((view) => {
			view.hidden = view.dataset.walletStep !== next;
		});
		if (dialog) {
			dialog.setAttribute(
				"aria-labelledby",
				next === "explainer"
					? "md-wallet-modal-title"
					: "md-wallet-modal-title-confirmation"
			);
		}
		if (fallback) fallback.hidden = !popupBlocked;
		if (retry) retry.hidden = !!popupBlocked;
	}

	function openPass() {
		const href = trigger.getAttribute("href") || "";
		if (fallbackLink) fallbackLink.href = href;

		// Passing 'noopener' in the features makes window.open return null, so sever opener here.
		const opened = href ? window.open(href, "_blank") : null;
		if (opened) {
			try {
				opened.opener = null;
			} catch (e) {}
		}
		return opened !== null;
	}

	function handleKeydown(e) {
		if (e.key === "Escape") {
			if (step === "explainer") {
				e.preventDefault();
				close();
			}
			return;
		}

		if (e.key !== "Tab") return;

		const els = focusables();
		if (!els.length) return;

		const first = els[0];
		const last = els[els.length - 1];

		if (e.shiftKey && document.activeElement === first) {
			e.preventDefault();
			last.focus();
		} else if (!e.shiftKey && document.activeElement === last) {
			e.preventDefault();
			first.focus();
		}
	}

	function open() {
		clearTimeout(closeTimer);
		setStep("explainer", false);
		modal.hidden = false;
		requestAnimationFrame(() => modal.classList.add("is-visible"));
		document.addEventListener("keydown", handleKeydown);
		setTimeout(() => {
			const first = focusables()[0];
			if (first) first.focus();
		}, 30);
	}

	function close() {
		modal.classList.remove("is-visible");
		document.removeEventListener("keydown", handleKeydown);
		clearTimeout(closeTimer);
		closeTimer = setTimeout(
			() => {
				modal.hidden = true;
			},
			prefersReducedMotion() ? 0 : 180
		);
		trigger.focus();
	}

	trigger.setAttribute("aria-haspopup", "dialog");
	trigger.addEventListener("click", (e) => {
		e.preventDefault();
		open();
	});

	modal.addEventListener("click", (e) => {
		if (e.target.closest(".js-wallet-close")) {
			close();
			return;
		}

		if (e.target.closest(".js-wallet-add")) {
			setStep("confirmation", !openPass());
			return;
		}

		if (e.target.closest(".js-wallet-retry-btn")) {
			setStep("confirmation", !openPass());
			return;
		}

		if (e.target.closest(".js-wallet-backdrop") && step === "explainer") {
			close();
		}
	});
}

/**
 * Create and inject consent modal HTML into the page
 */
function initConsentModal() {
	// Load consent configuration from JSON script
	const consentConfigScript = document.getElementById("consent-config");
	let headline = "Data Sharing Consent";

	if (consentConfigScript) {
		try {
			const configData = JSON.parse(consentConfigScript.textContent);
			if (configData.headline) {
				headline = configData.headline;
			}
		} catch (e) {
			console.warn("Could not parse consent config JSON");
		}
	}

	const modalHTML = `
    <div class="consent-modal">
      <div class="consent-modal__content">
        <button type="button" class="consent-modal__close btn--close" aria-label="Close modal">
          ${closeIcon}
        </button>
        <div class="consent-modal__header text-uppercase">
          <h4 class="t-h-4">${headline}</h4>
        </div>
        <div class="consent-modal__wrapper">
          <div id="consent-text-container"></div>
        </div>
        <div class="consent-modal__actions">
          <button type="submit" class="btn btn--primary btn--agree">I Agree</button>
        </div>
      </div>
    </div>
  `;

	// Insert modal at the beginning of the body
	document.body.insertAdjacentHTML("afterbegin", modalHTML);
}

function initBenefitsUsed() {
	initRevealToggles(document);
}

function initAddRaceModal() {
	const addRaceModal = document.querySelector(".race-modal");
	if (!addRaceModal) return;

	if (addRaceModal.parentElement !== document.body) {
		document.querySelectorAll(".race-modal").forEach((stale) => {
			if (stale !== addRaceModal) stale.remove();
		});
		document.body.appendChild(addRaceModal);
	}

	document.querySelectorAll(".btn--add-race").forEach((addRaceBtn) => {
		addRaceBtn.addEventListener("click", async () => {
			// Reset modal to add mode before opening
			resetRaceModalToAddMode();
			addRaceModal.classList.add("race-modal--active");

			// Fetch races from API when modal opens
			const dashboardContainer = document.querySelector(
				".membership-dashboard"
			);
			if (dashboardContainer) {
				const config = {
					apiUrl: dashboardContainer.getAttribute("data-api-url"),
					memberId: dashboardContainer.getAttribute("data-member-id"),
					signature: dashboardContainer.getAttribute("data-signature"),
				};
				await loadRacesIntoSelect(config);
			}
		});
	});

	const closeRaceModal = () => {
		addRaceModal.classList.remove("race-modal--active");
		// Reset to add mode when closing
		resetRaceModalToAddMode();
	};

	addRaceModal
		.querySelectorAll(".btn--close")
		.forEach((closeBtn) => closeBtn.addEventListener("click", closeRaceModal));

	// Close modal on overlay click
	addRaceModal.addEventListener("click", (e) => {
		if (e.target === addRaceModal) {
			closeRaceModal();
		}
	});

	document.addEventListener("keydown", (e) => {
		if (
			e.key === "Escape" &&
			addRaceModal.classList.contains("race-modal--active")
		) {
			closeRaceModal();
		}
	});

	// Initialize race form functionality
	initRaceForm();

	// Initialize race form submission
	initRaceFormSubmission();
}

/** Legacy tab row: kept in the DOM but hidden — the sticky pills are the live control. */
function initializeFilters() {
	const btnFilters = document.querySelectorAll(".member-benefits-panel__btn");
	btnFilters.forEach((btn) => {
		btn.addEventListener("click", (e) => {
			e.preventDefault();
			btnFilters.forEach((other) => {
				other.classList.remove("member-benefits-panel__btn--active");
			});
			btn.classList.add("member-benefits-panel__btn--active");
			filterBenefits();
		});
	});

	initCategoryDropdown();
}

function initCategoryDropdown() {
	const dropdown = document.querySelector(".js-benefits-category-dropdown");
	if (!dropdown) return;

	const toggle = dropdown.querySelector(".js-benefits-category-toggle");
	const content = dropdown.querySelector(".js-benefits-category-content");

	const setOpen = (isOpen) => {
		dropdown.classList.toggle("is-dropdown-active", isOpen);
		toggle.setAttribute("aria-expanded", isOpen);
		content.setAttribute("aria-hidden", !isOpen);
	};

	toggle.addEventListener("click", (e) => {
		e.preventDefault();
		setOpen(!dropdown.classList.contains("is-dropdown-active"));
	});

	document.addEventListener("click", (e) => {
		if (!dropdown.contains(e.target)) setOpen(false);
	});

	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") setOpen(false);
	});
}

function initCategoryPills() {
	const pillBar = document.querySelector(".js-md-pillbar");
	if (!pillBar) return;

	pillBar.addEventListener("click", (e) => {
		const pill = e.target.closest(".js-md-pill");
		if (!pill) return;
		e.preventDefault();
		selectCategoryPill(pill);
	});

	if ("IntersectionObserver" in window) {
		let observer = null;
		let observedOffset = null;

		const observePinnedState = () => {
			const offset = stickyTopOffset();
			if (observer && offset === observedOffset) return;

			if (observer) observer.disconnect();
			observedOffset = offset;

			observer = new IntersectionObserver(
				([entry]) =>
					pillBar.classList.toggle("is-pinned", !entry.isIntersecting),
				{ threshold: 1, rootMargin: `-${offset + 1}px 0px 0px 0px` }
			);
			observer.observe(pillBar);
		};

		observePinnedState();
		window.addEventListener("resize", observePinnedState, { passive: true });
	}
}

function stickyTopOffset() {
	return (
		(document.querySelector(".global-announcement")?.offsetHeight || 0) +
		(document.querySelector(".global-header")?.offsetHeight || 0)
	);
}

function selectCategoryPill(pill) {
	const pillBar = pill.closest(".js-md-pillbar");
	if (!pillBar) return;

	pillBar.querySelectorAll(".js-md-pill").forEach((other) => {
		const isActive = other === pill;
		other.classList.toggle("is-active", isActive);
		other.setAttribute("aria-pressed", isActive ? "true" : "false");
	});

	resetBenefitsPagination();
	filterBenefits();
}

function getActiveBenefitFilter() {
	const activePill = document.querySelector(".js-md-pill.is-active");
	if (activePill) {
		return (activePill.getAttribute("data-filter") || "all").toLowerCase();
	}

	const legacyTab = document.querySelector(
		".member-benefits-panel__btn--active"
	);
	if (legacyTab) {
		return (legacyTab.innerText || "").trim().toLowerCase();
	}

	return "all";
}

/**
 * Initialize the membership dashboard
 */
async function initializeDashboard(config) {
	try {
		// Load member info, savings data, and benefits on page load
		const scope = activeSavingsScope();
		const memberInfo = await fetchMemberInfo(config, SCOPE_PERIODS[scope]);

		savingsByScope[scope] = buildSavingsView(memberInfo, scope);

		updateMemberInfoDisplay(memberInfo);
		applySavingsScope();
		updateBenefitsDisplay(memberInfo.benefits);

		// Set up event listeners for benefit actions
		setupBenefitEventListeners(config, memberInfo);

		// Initialize benefit view tracking
		initBenefitViewTracking(config);
	} catch (error) {
		console.error("Error initializing dashboard:", error);
	}
}

/**
 * GET /api/members/<id> - Get main member information (status, expiration, balance).
 * `period` ("last_year" | "all_time") filters savings_list only; the rest of the
 * payload — balance, summary, benefits — is the same for both (BAN-950).
 */
async function fetchMemberInfo(config, period) {
	try {
		const periodParam = period ? `&period=${period}` : "";
		const response = await fetch(
			`${config.apiUrl}/members/${config.memberId}?signature=${config.signature}${periodParam}`,
			{
				method: "GET",
				headers: {
					Accept: "application/json",
					Authorization: `Bearer ${config.signature}`,
					"Content-Type": "application/json",
				},
			}
		);

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const memberInfo = await response.json();
		return memberInfo;
	} catch (error) {
		console.error("Error fetching member info:", error);
		throw error;
	}
}

/**
 * POST /api/members/<id>/benefits/<benefitId>/request - Request a benefit when codes unavailable
 * Returns 201 on success
 */
async function requestBenefit(config, benefitId) {
	try {
		const response = await fetch(
			`${config.apiUrl}/members/${config.memberId}/benefits/${benefitId}/request?signature=${config.signature}`,
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					Authorization: `Bearer ${config.signature}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({}),
			}
		);

		if (response.status === 201) {
			return { success: true };
		} else {
			throw new Error(`HTTP error! status: ${response.status}`);
		}
	} catch (error) {
		console.error("Error requesting benefit:", error);
		throw error;
	}
}

/**
 * POST /api/members/<id>/benefits/<benefitId>/redeem - Redeem a benefit
 * Returns updated benefit object with new status, store links, QR codes, etc.
 */
async function redeemBenefit(
	config,
	benefitId,
	memberInfo,
	consentBenefitId = benefitId
) {
	const benefit = memberInfo.benefits.find(
		(benefit) => parseInt(benefit.id) === parseInt(consentBenefitId)
	);
	if (!benefit) {
		throw new Error("Benefit not found");
	}

	const hasConsent = checkConsent(memberInfo, consentBenefitId);

	if (!hasConsent) {
		// Need to request consent first
		const requiredConsents = benefit.partner.required_consents || [];
		const partnerId = benefit.partner.id;

		try {
			await requestConsent(
				config,
				requiredConsents,
				partnerId,
				memberInfo,
				benefit.partner.name
			);
			// If we reach here, consent was granted, proceed with redemption
		} catch (error) {
			if (error.message === "CONSENT_DENIED") {
				return { success: false, reason: "consent_denied" };
			}
			throw error;
		}
	}

	// Proceed with benefit redemption
	try {
		const response = await fetch(
			`${config.apiUrl}/members/${config.memberId}/benefits/${benefitId}/redeem?signature=${config.signature}`,
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					Authorization: `Bearer ${config.signature}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					memberId: config.memberId,
					benefitId: benefitId,
					timestamp: new Date().toISOString(),
				}),
			}
		);

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const redemptionResult = await response.json();

		// URL returned to caller for handling
		// if (redemptionResult.url) {
		//   window.open(redemptionResult.url, '_blank');
		// }

		// Return the updated benefit object with coupon.code and url
		return {
			success: true,
			benefit: redemptionResult,
		};
	} catch (error) {
		console.error("Error redeeming benefit:", error);
		throw error;
	}
}

function checkConsent(memberInfo, benefitId) {
	// Check if consent modal is enabled
	const consentConfigScript = document.getElementById("consent-config");
	let consentEnabled = false;

	if (consentConfigScript) {
		try {
			const configData = JSON.parse(consentConfigScript.textContent);
			consentEnabled = configData.enabled || false;
		} catch (e) {
			console.warn("Could not parse consent config JSON");
		}
	}

	// If consent modal is disabled, always return true (no consent needed)
	if (!consentEnabled) return true;

	const benefit = memberInfo.benefits.find(
		(benefit) => parseInt(benefit.id) === parseInt(benefitId)
	);
	if (!benefit) return false;

	const memberConsents = memberInfo.consents || [];
	const requiredConsents = benefit.partner.required_consents || [];
	const partnerId = benefit.partner.id;

	// If no consent is required for this partner, allow access
	if (requiredConsents.length === 0) return true;

	// Check if every required consent is granted for this specific partner
	const hasAllRequiredConsents = requiredConsents.every((consentType) => {
		return memberConsents.some(
			(consent) =>
				consent.type === consentType &&
				consent.partner_id === partnerId &&
				consent.status === "granted"
		);
	});

	return hasAllRequiredConsents;
}

/**
 * Request consent from user via modal
 */
async function requestConsent(
	config,
	requiredConsents,
	partnerId,
	memberInfo,
	partnerName
) {
	return new Promise((resolve, reject) => {
		const consentModal = document.querySelector(".consent-modal");
		const consentTextContainer = document.getElementById(
			"consent-text-container"
		);
		const agreeBtn = consentModal.querySelector(".btn--agree");
		const closeBtn = consentModal.querySelector(".btn--close");

		// Load consent configuration from JSON script
		const consentConfigScript = document.getElementById("consent-config");
		let consentConfig = {
			bodyText: "Do you consent to share your data with [Partner Name]?",
			checkboxLabel: "I agree to share my data with [Partner Name]",
			confirmButtonLabel: "Confirm",
			companyName: "Our Company",
		};

		if (consentConfigScript) {
			try {
				const configData = JSON.parse(consentConfigScript.textContent);
				consentConfig = { ...consentConfig, ...configData };
			} catch (e) {
				console.warn("Could not parse consent config JSON");
			}
		}

		// Replace tokens in all config fields
		const replaceTokens = (text) => {
			return text
				.replace(/\[Partner Name\]/g, partnerName)
				.replace(/\[Your Company\]/g, consentConfig.companyName);
		};

		const bodyText = replaceTokens(consentConfig.bodyText);
		const checkboxLabel = replaceTokens(consentConfig.checkboxLabel);
		const confirmButtonLabel = replaceTokens(consentConfig.confirmButtonLabel);

		// Build modal content with checkbox and confirm button
		const checkboxId = "consent-checkbox-" + Date.now();
		consentTextContainer.innerHTML = `
      <div class="consent-modal__body">${bodyText}</div>
      <div class="consent-modal__checkbox-container">
        <input type="checkbox" id="${checkboxId}" class="consent-modal__checkbox" />
        <label for="${checkboxId}" class="consent-modal__checkbox-label">${checkboxLabel}</label>
      </div>
    `;

		// Update confirm button label
		agreeBtn.textContent = confirmButtonLabel;
		agreeBtn.disabled = true;
		agreeBtn.classList.add("btn--disabled");

		// Get checkbox element
		const checkbox = consentModal.querySelector(`#${checkboxId}`);

		// Show modal
		consentModal.classList.add("consent-modal--active");

		const handleCheckboxChange = () => {
			if (checkbox.checked) {
				agreeBtn.disabled = false;
				agreeBtn.classList.remove("btn--disabled");
			} else {
				agreeBtn.disabled = true;
				agreeBtn.classList.add("btn--disabled");
			}
		};

		const handleOverlayClick = (e) => {
			if (e.target.classList.contains("consent-modal")) {
				handleClose();
			}
		};

		const handleAgree = async () => {
			if (!checkbox.checked) return; // Double check

			try {
				// Save all required consents
				for (const consentType of requiredConsents) {
					await saveConsent(config, consentType, partnerId);

					// Add consent to memberInfo to avoid re-asking during session
					if (!memberInfo.consents) {
						memberInfo.consents = [];
					}
					memberInfo.consents.push({
						type: consentType,
						status: "granted",
						partner_id: partnerId,
					});
				}

				// Hide modal and cleanup
				cleanup();
				resolve();
			} catch (error) {
				console.error("Error saving consent:", error);
				cleanup();
				reject(error);
			}
		};

		const handleClose = () => {
			cleanup();
			reject(new Error("CONSENT_DENIED"));
		};

		const cleanup = () => {
			// Hide modal
			consentModal.classList.remove("consent-modal--active");

			// Reset button state
			agreeBtn.disabled = false;
			agreeBtn.classList.remove("btn--disabled");

			// Clean up listeners
			checkbox.removeEventListener("change", handleCheckboxChange);
			agreeBtn.removeEventListener("click", handleAgree);
			closeBtn.removeEventListener("click", handleClose);
			consentModal.removeEventListener("click", handleOverlayClick);
		};

		// Add event listeners
		checkbox.addEventListener("change", handleCheckboxChange);
		agreeBtn.addEventListener("click", handleAgree);
		closeBtn.addEventListener("click", handleClose);
		consentModal.addEventListener("click", handleOverlayClick);
	});
}

/**
 * POST /api/members/<id>/consents - Save member consent
 */
async function saveConsent(config, consentType, partnerId) {
	try {
		const response = await fetch(
			`${config.apiUrl}/members/${config.memberId}/consents?signature=${config.signature}`,
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					Authorization: `Bearer ${config.signature}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					type: consentType,
					status: "granted",
					timestamp: new Date().toISOString(),
					partner_id: partnerId,
				}),
			}
		);

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const consentResult = await response.json();
		return consentResult;
	} catch (error) {
		console.error("Error saving consent:", error);
		throw error;
	}
}

/**
 * POST /members/<id>/metrics - Record benefit metrics (view/click)
 */
async function recordBenefitMetric(config, benefitIds = [], metricType) {
	try {
		const unixTimestamp = Math.floor(Date.now() / 1000);

		const metrics = benefitIds
			.map((benefitId) => {
				const id = parseInt(benefitId);
				return isNaN(id)
					? null
					: {
							event: metricType,
							benefit_id: id,
							created_at: unixTimestamp,
						};
			})
			.filter((metric) => metric !== null);

		if (metrics.length === 0) {
			return null;
		}

		const response = await fetch(
			`${config.apiUrl}/members/${config.memberId}/metrics?signature=${config.signature}`,
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					Authorization: `Bearer ${config.signature}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify(metrics),
			}
		);

		if (!response.ok) {
			console.warn(`Failed to record metric: ${response.status}`);
			return null; // Don't throw error for metrics as they're not critical
		}

		const metricResult = await response.json();
		return metricResult;
	} catch (error) {
		console.warn("Error recording metric:", error);
		// Don't throw error for metrics as they're not critical to user experience
		return null;
	}
}

/**
 * Update member info display in the UI
 */
function updateMemberInfoDisplay(memberInfo) {
	if (!memberInfo) return;

	const balanceElement = document.querySelector(
		".member-savings__amount--active"
	);

	const pendingBalanceElement = document.querySelector(
		".member-savings__amount--pending"
	);

	const showBalanceError = (type) => {
		if (type === "active") {
			balanceElement.innerHTML = "<small>Error loading balance</small>";
		} else if (type === "pending") {
			pendingBalanceElement.innerHTML = "<small>Error loading balance</small>";
		}
	};

	// Update balance if provided
	if (memberInfo.balance !== undefined) {
		if (balanceElement) {
			if (memberInfo.balance.amount !== undefined) {
				balanceElement.textContent = formatSavingsAmount(
					memberInfo.balance.amount
				);
			} else {
				showBalanceError("active");
			}
		}

		if (pendingBalanceElement) {
			if (memberInfo.balance.pending_amount !== undefined) {
				pendingBalanceElement.textContent = formatSavingsAmount(
					memberInfo.balance.pending_amount
				);
			} else {
				showBalanceError("pending");
			}
		}
	} else {
		showBalanceError("active");
		showBalanceError("pending");
	}
}

const SAVINGS_TYPE_LABELS = {
	recurring_order_discount: "10% discount from bandit",
	complimentary_gift_card: "$50 gift card ($75 gift card in year 2+)",
	benefit: "partner benefits including cashback value if used",
	complimentary_product: "Two Pairs of Member Socks, Annually",
	recurring_shipping_discount:
		"free shipping for orders under shipping minimum",
	referral: "referral credit",
};

const SCOPE_PERIODS = { year: "last_year", all: "all_time" };

// One entry per scope: { total, rows }, filled from its own period-filtered fetch.
const savingsByScope = { year: null, all: null };

let savingsConfig = null;

// Cents only show up when there are any: $75, but $11.68 and $157.50.
function formatSavingsAmount(value) {
	const amount = Number(value) || 0;
	const hasCents = Math.round(amount * 100) % 100 !== 0;

	return `$${amount.toLocaleString("en-US", {
		minimumFractionDigits: hasCents ? 2 : 0,
		maximumFractionDigits: 2,
	})}`;
}

function activeSavingsScope() {
	const active = document.querySelector(".js-md-scope-seg.is-active");
	return (active && active.dataset.scope) || "year";
}

function savingsRowLabel(entry) {
	// Benefit-linked rows are grouped per benefit, so the generic type label
	// would repeat across them.
	if (entry.benefit && entry.benefit.name) return entry.benefit.name;

	return SAVINGS_TYPE_LABELS[entry.type] || "";
}

/**
 * Turns one member payload into what the savings tile shows for that scope.
 * All Time takes its total from summary.savings; This Year has no such
 * aggregate, so the period-filtered rows are summed instead.
 */
function buildSavingsView(memberInfo, scope) {
	const entries = Array.isArray(memberInfo.savings_list)
		? memberInfo.savings_list
		: [];

	const rows = [];
	let listTotal = 0;

	entries.forEach((entry) => {
		if (!entry || !entry.type || entry.amount === undefined) return;

		const label = savingsRowLabel(entry);
		if (!label) return;

		const amount = parseFloat(entry.amount) || 0;
		listTotal += amount;

		if (amount > 0) rows.push({ label, amount });
	});

	const summary = memberInfo.summary || {};
	const total =
		scope === "all" && summary.savings !== undefined
			? parseFloat(summary.savings) || 0
			: listTotal;

	return { total, rows };
}

function renderSavingsBreakdown(rows) {
	const breakdownContainer = document.querySelector(".benefits-used");
	if (!breakdownContainer) return;

	breakdownContainer.innerHTML = "";

	rows.forEach((row) => {
		const itemDiv = document.createElement("div");
		itemDiv.className = "benefits-used__item";
		itemDiv.innerHTML = `
			<div class="benefits-used__item__title text-uppercase">${escapeHtml(row.label)}</div>
			<div class="benefits-used__item__amount">${formatSavingsAmount(row.amount)}</div>
		`;
		breakdownContainer.appendChild(itemDiv);
	});
}

function applySavingsScope() {
	const scope = activeSavingsScope();
	const view = savingsByScope[scope];

	if (view) {
		const totalEl = document.querySelector(".member-savings__amount--total");
		if (totalEl) totalEl.textContent = formatSavingsAmount(view.total);

		renderSavingsBreakdown(view.rows);
	}

	const footEl = document.querySelector(".js-md-savings-foot");
	if (footEl) {
		const copy =
			scope === "year" ? footEl.dataset.footYear : footEl.dataset.footAll;
		if (copy) footEl.textContent = copy;
	}
}

async function loadSavingsScope(scope) {
	if (savingsByScope[scope] || !savingsConfig) return;

	const memberInfo = await fetchMemberInfo(savingsConfig, SCOPE_PERIODS[scope]);
	savingsByScope[scope] = buildSavingsView(memberInfo, scope);
}

function initSavingsScope(config) {
	const group = document.querySelector(".js-md-savings-scope");
	if (!group) return;

	savingsConfig = config;

	group.addEventListener("click", async (e) => {
		const seg = e.target.closest(".js-md-scope-seg");
		if (!seg || seg.classList.contains("is-active")) return;

		group.querySelectorAll(".js-md-scope-seg").forEach((other) => {
			const isActive = other === seg;
			other.classList.toggle("is-active", isActive);
			other.setAttribute("aria-pressed", isActive ? "true" : "false");
		});

		const scope = activeSavingsScope();

		if (!savingsByScope[scope]) {
			group.setAttribute("aria-busy", "true");
			try {
				await loadSavingsScope(scope);
			} catch (error) {
				console.error("Error fetching savings for scope:", scope, error);
			} finally {
				group.removeAttribute("aria-busy");
			}
		}

		applySavingsScope();
	});
}

/**
 * Load static benefits from JSON script tag
 */
function loadStaticBenefits() {
	const staticBenefitsScript = document.getElementById("static-benefits");
	if (!staticBenefitsScript) return [];

	try {
		const staticBenefits = JSON.parse(staticBenefitsScript.textContent);
		return Array.isArray(staticBenefits) ? staticBenefits : [];
	} catch {
		console.warn("Could not parse static benefits JSON");
		return [];
	}
}

/**
 * Parse benefits order configuration from JSON script
 * Returns {banditFirst: boolean, order: array of {partner, benefit}}
 */
function parseBenefitsOrder() {
	const orderConfigScript = document.getElementById("benefits-order-config");
	if (!orderConfigScript) return { banditFirst: true, order: [] };

	try {
		const config = JSON.parse(orderConfigScript.textContent);
		if (!config || typeof config !== "object")
			return { banditFirst: true, order: [] };

		const order = (config.order || []).map((item, index) => ({
			partner: (item.partner || "").toLowerCase(),
			benefit: (item.benefit || "").toLowerCase(),
			order: index,
		}));

		return {
			banditFirst: config.banditFirst !== false,
			order,
		};
	} catch {
		console.warn("Could not parse benefits order JSON");
		return { banditFirst: true, order: [] };
	}
}

/**
 * Sort benefits according to configured order
 * Bandit benefits come first if banditFirst is true
 * Benefits not in order list are sorted alphabetically
 */
function sortBenefitsByOrder(benefits, orderConfig) {
	const { banditFirst, order } = orderConfig || {
		banditFirst: true,
		order: [],
	};

	return [...benefits].sort((a, b) => {
		// Sort by sort_order from API if available
		const aSortOrder =
			a.sort_order !== undefined && a.sort_order !== null
				? a.sort_order
				: Infinity;
		const bSortOrder =
			b.sort_order !== undefined && b.sort_order !== null
				? b.sort_order
				: Infinity;

		if (aSortOrder !== bSortOrder) {
			return aSortOrder - bSortOrder;
		}

		const aPartner = (a.partner?.name || "").toLowerCase().trim();
		const aBenefit = (a.name || "").toLowerCase().trim();
		const bPartner = (b.partner?.name || "").toLowerCase().trim();
		const bBenefit = (b.name || "").toLowerCase().trim();

		// Bandit benefits first if enabled
		if (banditFirst) {
			const aIsBandit = aPartner === "bandit running";
			const bIsBandit = bPartner === "bandit running";
			if (aIsBandit && !bIsBandit) return -1;
			if (!aIsBandit && bIsBandit) return 1;
		}

		// Find order index for each benefit
		const aOrderItem = order.find(
			(item) => item.partner === aPartner && item.benefit === aBenefit
		);
		const bOrderItem = order.find(
			(item) => item.partner === bPartner && item.benefit === bBenefit
		);

		// Both in order list - sort by order
		if (aOrderItem && bOrderItem) {
			return aOrderItem.order - bOrderItem.order;
		}

		// Only one in order list - prioritize the one in the list
		if (aOrderItem) return -1;
		if (bOrderItem) return 1;

		// Neither in order list - sort alphabetically by partner, then by benefit name
		if (aPartner !== bPartner) {
			return aPartner.localeCompare(bPartner);
		}
		return aBenefit.localeCompare(bBenefit);
	});
}

/**
 * Update benefits display in the UI
 */
function updateBenefitsDisplay(benefitsData) {
	if (!benefitsData || !Array.isArray(benefitsData)) return;

	const benefitsContainer = document.querySelector(".member-benefits-list");
	if (!benefitsContainer) return;

	// Load static benefits
	const staticBenefits = loadStaticBenefits();

	// Merge static benefits (Bandit) first, then API benefits (partners)
	let allBenefits = benefitsData;

	// Apply custom ordering if configured
	const orderConfig = parseBenefitsOrder();

	if (orderConfig.order.length > 0 || orderConfig.banditFirst) {
		allBenefits = sortBenefitsByOrder(allBenefits, orderConfig);
	}

	allBenefits = [...staticBenefits, ...allBenefits];

	// Clear existing items
	benefitsContainer.innerHTML = "";

	// Create benefit items
	allBenefits.forEach((benefit) => {
		const benefitElement = createBenefitElement(benefit);
		benefitsContainer.appendChild(benefitElement);
	});
	reloadBenefitsFilters(allBenefits);
	novelPassLinksReplace();
	resetBenefitsPagination();
	filterBenefits();
}

function reloadBenefitsFilters(benefitsData) {
	const categories = benefitsData.map((benefit) => benefit.category);
	const uniqueCategories = [...new Set(categories)].filter(
		(category) => category !== "" && category !== "null" && category !== null
	);

	const labelsCategories = uniqueCategories.map((category) =>
		category.toUpperCase().replaceAll("_", " ")
	);

	renderCategoryPills(uniqueCategories, labelsCategories);

	const categoryDropdown = document.querySelector(
		".js-benefits-category-dropdown"
	);
	if (categoryDropdown) {
		categoryDropdown.classList.toggle(
			"is-hidden",
			uniqueCategories.length === 0
		);
	}

	const benefitsCategoryList = document.querySelector(
		".js-benefits-category-list"
	);
	if (!benefitsCategoryList) return;

	updateCheckboxOptions(
		benefitsCategoryList,
		uniqueCategories,
		labelsCategories
	);

	function updateCheckboxOptions(listEl, options, labels) {
		listEl.innerHTML = "";
		options.forEach((option, index) => {
			const li = document.createElement("li");
			li.className = "benefits-filter__option";

			const label = document.createElement("label");
			label.htmlFor = `filter-category-${index}`;
			label.className =
				"benefits-filter__option__label f-h f-a-c f-j-s user-select-disable";

			const checkbox = document.createElement("input");
			checkbox.type = "checkbox";
			checkbox.id = `filter-category-${index}`;
			checkbox.value = option;
			checkbox.className = "js-category-filter";
			checkbox.addEventListener("change", filterBenefits);

			const span = document.createElement("span");
			span.className = "t-l-1";
			span.textContent = labels[index];

			label.appendChild(checkbox);
			label.appendChild(span);
			li.appendChild(label);
			listEl.appendChild(li);
		});
	}
}

function renderCategoryPills(categories, labels) {
	const pillList = document.querySelector(".js-md-pills");
	if (!pillList) return;

	pillList
		.querySelectorAll(".js-md-pill[data-dynamic='true']")
		.forEach((pill) => pill.remove());

	categories.forEach((category, index) => {
		const pill = document.createElement("button");
		pill.type = "button";
		pill.className = "md-pill js-md-pill";
		pill.setAttribute("data-dynamic", "true");
		pill.setAttribute("data-filter", String(category).toLowerCase());
		pill.setAttribute("aria-pressed", "false");
		pill.textContent = labels[index];
		pillList.appendChild(pill);
	});
}

function filterBenefits() {
	const categoryCheckboxes = document.querySelectorAll(
		".js-category-filter:checked"
	);
	const selectedCategories = Array.from(categoryCheckboxes).map((cb) =>
		String(cb.value).toLowerCase()
	);

	const activeFilter = getActiveBenefitFilter();
	const benefits = document.querySelectorAll(".member-benefits-list__item");

	benefits.forEach((benefit) => {
		const category = (
			benefit.getAttribute("data-category") || ""
		).toLowerCase();
		const partner = (benefit.getAttribute("data-partner") || "").toLowerCase();

		let visible = true;

		// Legacy (hidden) category dropdown — multi-select, still honoured.
		if (
			selectedCategories.length > 0 &&
			!selectedCategories.includes(category)
		) {
			visible = false;
		}

		if (activeFilter === "bandit") {
			if (partner !== "bandit running") visible = false;
		} else if (activeFilter === "partners") {
			if (partner === "bandit running") visible = false;
		} else if (activeFilter && activeFilter !== "all") {
			if (category !== activeFilter) visible = false;
		}

		benefit.classList.toggle("is-filtered-out", !visible);
	});

	applyBenefitsPagination();
}

let benefitsPageSize = 20;
let benefitsShown = 20;

function getBenefitsBatchSize() {
	return window.matchMedia("(max-width: 480px)").matches ? 6 : 20;
}

function resetBenefitsPagination() {
	benefitsPageSize = getBenefitsBatchSize();
	benefitsShown = benefitsPageSize;
}

function initBenefitsPagination() {
	resetBenefitsPagination();

	const moreBtn = document.querySelector(".js-md-benefits-more-btn");
	if (moreBtn) {
		moreBtn.addEventListener("click", (e) => {
			e.preventDefault();
			benefitsShown += getBenefitsBatchSize();
			applyBenefitsPagination();
		});
	}

	const mq = window.matchMedia("(max-width: 480px)");
	// Re-sync the page size without collapsing what the visitor already paged in.
	const onChange = (matches) => {
		benefitsPageSize = matches ? 6 : 20;
		benefitsShown = matches
			? Math.min(benefitsShown, 6)
			: Math.max(benefitsShown, 20);
		applyBenefitsPagination();
	};
	if (typeof mq.addEventListener === "function") {
		mq.addEventListener("change", (e) => onChange(e.matches));
	}
}

function applyBenefitsPagination() {
	const items = Array.from(
		document.querySelectorAll(".member-benefits-list__item")
	);
	const visibleItems = items.filter(
		(item) => !item.classList.contains("is-filtered-out")
	);

	items.forEach((item) => item.classList.remove("is-paged-out"));
	visibleItems.forEach((item, index) => {
		item.classList.toggle("is-paged-out", index >= benefitsShown);
	});

	const moreWrap = document.querySelector(".js-md-benefits-more");
	if (moreWrap) moreWrap.hidden = visibleItems.length <= benefitsShown;

	const emptyEl = document.querySelector(".js-md-benefits-empty");
	if (emptyEl) emptyEl.hidden = items.length === 0 || visibleItems.length > 0;
}

function formatBundleDate(value) {
	if (!value) return "";

	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return "";

	return date.toLocaleDateString("en-GB", {
		day: "numeric",
		month: "short",
		year: "numeric",
	});
}

function bundleOrderLabel(orderNumber) {
	const order = String(orderNumber);

	return order.startsWith("#") ? order : `#${order}`;
}

function hasRedemptionDetails(entry) {
	return Boolean(
		entry.redeemed && entry.has_redemption_limit && entry.order_number
	);
}

function redemptionStatusHtml(entry, className) {
	if (!entry.redeemed) return "";

	const statusParts = [];
	if (hasRedemptionDetails(entry)) {
		const redeemedDate = formatBundleDate(entry.date);
		if (redeemedDate)
			statusParts.push(redeemedDate.replace(/ (\d{4})$/, ", $1"));
		statusParts.push(bundleOrderLabel(entry.order_number));
	}

	return `<p class="${className}">${redeemedCheckIcon}Redeemed${
		statusParts.length ? ` ${escapeHtml(statusParts.join(", "))}` : ""
	}</p>`;
}

function bundleEntries(benefit) {
	return [benefit, ...(benefit.children || [])];
}

function visibleBundleEntries(benefit) {
	return [
		benefit,
		...(benefit.children || []).filter(
			(child) => !("available" in child) || Boolean(child.available)
		),
	];
}

function applicableEntryCode(entry) {
	const entryCode = entry.coupon && entry.coupon.code;

	return entryCode && !benefitIsUnavailable(entry) ? entryCode : "";
}

function createBundleRowHtml(entry, bundleBenefitId, showAction) {
	const entryCode = entry.coupon && entry.coupon.code;
	const applicableCode = applicableEntryCode(entry);

	const codeHtml = applicableCode
		? `<p class="md-bundle__code">
				<span class="md-bundle__code-value">${escapeHtml(entryCode)}</span>
				<button type="button" class="md-bundle__copy btn--copy-code" data-code="${escapeHtml(
					entryCode
				)}" aria-label="Copy code ${escapeHtml(entryCode)}">Copy</button>
			</p>`
		: "";

	const statusHtml = entry.available
		? ""
		: redemptionStatusHtml(entry, "md-bundle__status");

	const notes = [];
	if (entry.type === "cashback" && !entryCode && !entry.redeemed) {
		notes.push("Credited automatically within 7 days of purchase.");
	}
	if (entry.ends_at) {
		const endsAt = formatBundleDate(entry.ends_at);
		if (endsAt) notes.push(`Active till ${endsAt}`);
	}

	const notesHtml = notes
		.map((note) => `<p class="md-bundle__note">${escapeHtml(note)}</p>`)
		.join("");

	const actionHtml =
		showAction && applicableCode
			? benefitActionHtml(entry, bundleBenefitId)
			: "";
	const isLimitReached =
		entry.has_redemption_limit && entry.redeemed && benefitIsUnavailable(entry);

	return `
		<li class="md-bundle__item${
			isLimitReached ? " md-bundle__item--limit-reached" : ""
		}">
			<div class="md-bundle__header">
				<p class="md-bundle__name">${escapeHtml(entry.name || "")}</p>
				${
					isLimitReached
						? `<span class="md-bundle__badge">Limit reached</span>`
						: ""
				}
			</div>
			${codeHtml}
			${statusHtml}
			${actionHtml}
			${notesHtml}
		</li>
	`;
}

function bundleSummaryLabel(entries) {
	const cashbackCount = entries.filter(
		(entry) => entry.type === "cashback"
	).length;
	const benefitCount = entries.length - cashbackCount;

	if (!benefitCount) {
		return `${cashbackCount} cashback benefit${cashbackCount === 1 ? "" : "s"}`;
	}

	const benefitLabel = `${benefitCount} benefit${benefitCount === 1 ? "" : "s"}`;

	return cashbackCount ? `${benefitLabel} + cashback` : benefitLabel;
}

function bundleRedeemedCaptionHtml(entries) {
	const parts = entries
		.filter((entry) => entry.name && !benefitIsUnavailable(entry))
		.map((entry) =>
			entry.coupon && entry.coupon.code
				? `copy the ${entry.name} code and paste it at checkout`
				: `${entry.name} applies automatically`
		);
	if (!parts.length) return "";

	const sentence = parts.join("; ");

	return `<p class="md-benefit__caption">${escapeHtml(
		sentence.charAt(0).toUpperCase() + sentence.slice(1)
	)}.</p>`;
}

function bundleNeedsRedeem(benefit) {
	if (benefitIsUnavailable(benefit)) return false;

	return benefit.redemption_required
		? !applicableEntryCode(benefit)
		: !benefit.redeemed;
}

function issuedBundleButtonHtml(benefit, entries) {
	const entryWithCode = entries.find((entry) => applicableEntryCode(entry));
	if (entryWithCode) return benefitActionHtml(entryWithCode, benefit.id);

	const partnerUrl = benefit.url || benefit.partner?.url;
	const hasAvailableEntry = bundleEntries(benefit).some(
		(entry) => !benefitIsUnavailable(entry)
	);
	const actionClass = "md-btn md-btn--solid md-bundle__action";
	const idAttr = ` data-benefit-id="${escapeHtml(benefit.id)}"`;

	if (hasAvailableEntry && partnerUrl) {
		return `<a href="${escapeHtml(partnerUrl)}" target="_blank" rel="noopener noreferrer" class="${actionClass} btn--visit-partner"${idAttr}>${escapeHtml(
			benefit.primary_button_label || "REDEEM"
		)}</a>`;
	}

	return `<button type="button" class="${actionClass} btn--redeem"${idAttr} disabled>REDEEMED</button>`;
}

function createBundleHtml(benefit) {
	const entries = visibleBundleEntries(benefit);
	const hasCashback = bundleEntries(benefit).some(
		(entry) => entry.type === "cashback"
	);
	const hasSingleButton = benefit.bundle_type === "strict" || hasCashback;
	const needsRedeem = bundleNeedsRedeem(benefit);
	const showRowActions = !needsRedeem && !hasSingleButton;

	const rowsHtml = entries
		.map((entry) => createBundleRowHtml(entry, benefit.id, showRowActions))
		.join("");

	let buttonHtml = "";
	if (needsRedeem) {
		buttonHtml = benefitActionHtml(benefit, benefit.id);
	} else if (hasSingleButton) {
		buttonHtml = issuedBundleButtonHtml(benefit, entries);
	}

	const hasRowActions =
		showRowActions && entries.some((entry) => applicableEntryCode(entry));
	const captionHtml =
		!needsRedeem && !benefit.redemption_required && !hasRowActions
			? bundleRedeemedCaptionHtml(entries)
			: "";

	return `
		<div class="md-bundle">
			<p class="md-bundle__heading">What&rsquo;s included &middot; ${escapeHtml(
				bundleSummaryLabel(entries)
			)}</p>
			<ul class="md-bundle__list">${rowsHtml}</ul>
			${buttonHtml}
			${captionHtml}
		</div>
	`;
}

function benefitIsUnavailable(entry) {
	return "available" in entry && !entry.available;
}

function benefitActionHtml(entry, bundleBenefitId = null) {
	if (entry.type === "static") return "";

	const isBundleRow = bundleBenefitId !== null;
	const entryCode = entry.coupon && entry.coupon.code;
	const isUnavailable = benefitIsUnavailable(entry);

	//TODO Please remove/update after adding new benefit settings to disable benefits
	const isDisabled = entry.id === 11 || isUnavailable;

	const redemptionRequired =
		entry.redemption_required !== undefined ? entry.redemption_required : false;
	const isRedeemable = entry.redeemable !== undefined ? entry.redeemable : true;

	const label = escapeHtml(
		isUnavailable ? "REDEEMED" : entry.primary_button_label || "REDEEM"
	);
	const actionClass = `md-btn md-btn--solid${
		isBundleRow ? " md-bundle__action" : ""
	}`;
	const idAttr = ` data-benefit-id="${escapeHtml(entry.id)}"`;
	const bundleAttr = isBundleRow
		? ` data-bundle-id="${escapeHtml(bundleBenefitId)}"`
		: "";

	const codeAttr = entryCode && !isDisabled ? ` data-code="${escapeHtml(entryCode)}"` : "";
	const disabledAttr = isDisabled ? " disabled" : "";

	if (entryCode && entry.url && !isDisabled) {
		return `
			<a href="${escapeHtml(entry.url)}" target="_blank" rel="noopener noreferrer" class="${actionClass} btn--visit-partner"${idAttr}${codeAttr}>${label}</a>
		`;
	}

	if (redemptionRequired && !isRedeemable) {
		return `
			<button type="button" class="${actionClass} btn--request"${idAttr}>REQUEST</button>
		`;
	}

	return `
		<button type="button" class="${actionClass} btn--redeem"${idAttr}${bundleAttr}${codeAttr}${disabledAttr}>${label}</button>
	`;
}

/**
 * Create a benefit element
 */
function createBenefitElement(benefit) {
	const benefitDiv = document.createElement("div");
	benefitDiv.className = "member-benefits-list__item md-benefit";
	benefitDiv.setAttribute("data-benefit-id", benefit.id);

	benefitDiv.setAttribute("data-type", benefit.type);
	benefitDiv.setAttribute("data-category", benefit.category);
	benefitDiv.setAttribute("data-partner", benefit.partner?.name || "");

	const benefitImage = benefit.image || benefit.partner?.image || "";

	// Check if benefit has coupon code
	const hasCoupon = benefit.coupon && benefit.coupon.code;
	const isBundle = Boolean(benefit.children && benefit.children.length);
	const bundleHasCode =
		isBundle &&
		visibleBundleEntries(benefit).some(
			(entry) =>
				entry.coupon && entry.coupon.code && !benefitIsUnavailable(entry)
		);

	const actionHtml = benefitActionHtml(benefit);

	const benefitCardName = isBundle
		? benefit.bundle || benefit.name || ""
		: benefit.name || "";

	// The code chip is gone, so every available code has to be readable (and
	// selectable) inside the caption itself.
	const codes = [];
	if (hasCoupon && !benefitIsUnavailable(benefit)) codes.push(benefit.coupon.code);

	const codeMarkup = codes
		.map((code) => `<span class="md-benefit__code">${escapeHtml(code)}</span>`)
		.join(" &amp; ");

	const suppressCaption =
		benefit.type === "static" && String(benefit.id || "").endsWith("benefit_gift_card");

	let captionHtml = "";
	if (!suppressCaption) {
		if (codes.length) {
			captionHtml = `<p class="md-benefit__caption">Enter code ${codeMarkup} at checkout to receive your member discount.</p>`;
		} else if (actionHtml.trim() === "") {
			captionHtml = `<p class="md-benefit__caption">Applied automatically at checkout &mdash; no code needed.</p>`;
		}
	}

	// Only the label signals a code behind the reveal, so it has to stay content-aware.
	let benefitButtonText = "Code & Details";
	if (benefit.secondary_button_label) {
		benefitButtonText = benefit.secondary_button_label;
	} else if (!hasCoupon && !bundleHasCode && !benefit.redeemable) {
		benefitButtonText = "Details";
	}

	const descriptionHtml = benefit.description
		? normalizeHtml(String(benefit.description).replaceAll("\n", "<br>"))
		: "";

	const hasLogo = Boolean(benefitImage);

	const revealBodyHtml = isBundle
		? createBundleHtml(benefit)
		: `<div class="md-benefit__actions">
							${
								benefit.available
									? ""
									: redemptionStatusHtml(benefit, "md-benefit__status")
							}
							${actionHtml}
							${captionHtml}
						</div>`;

	benefitDiv.innerHTML = `
		<div class="md-benefit__body">
			${
				hasLogo
					? `<div class="md-benefit__logo">
				<img src="${escapeHtml(benefitImage)}" alt="${escapeHtml(benefit.name || "")}" loading="lazy">
			</div>`
					: ``
			}
			<p class="md-benefit__name">${escapeHtml(benefitCardName)}</p>
		</div>
		<div class="md-benefit__footer">
			<div class="md-benefit__rule"></div>
			<button
				type="button"
				class="md-benefit__details btn--learn-more"
				data-benefit-id="${benefit.id}"
				aria-expanded="false"
			>
				<span class="md-benefit__details-label">${escapeHtml(benefitButtonText)}</span>
				<span class="md-benefit__chev">${chevronIcon}</span>
			</button>
			<div class="md-reveal js-md-benefit-reveal" data-open="false">
				<div class="md-reveal__clip">
					<div class="md-reveal__inner md-benefit__reveal-body">
						<div class="md-benefit__desc">${descriptionHtml}</div>
						${revealBodyHtml}
					</div>
				</div>
			</div>
		</div>
	`;

	const logoImg = benefitDiv.querySelector(".md-benefit__logo img");
	if (logoImg) {
		logoImg.addEventListener("error", () => {
			const slot = logoImg.closest(".md-benefit__logo");
			if (slot) slot.remove();
		});
	}

	return benefitDiv;
}

function legacyCopy(text) {
	// Fallback for non-secure contexts / older Safari.
	const input = document.createElement("textarea");
	input.value = text;
	input.setAttribute("readonly", "readonly");
	input.style.position = "fixed";
	input.style.opacity = "0";
	document.body.appendChild(input);
	input.select();
	let ok = false;
	try {
		ok = document.execCommand("copy");
	} catch {
		ok = false;
	}
	input.remove();
	return ok;
}

function copyBenefitCode(text) {
	if (!text) return Promise.resolve(false);

	if (navigator.clipboard && navigator.clipboard.writeText) {
		return navigator.clipboard
			.writeText(text)
			.then(() => true)
			.catch(() => legacyCopy(text));
	}

	return Promise.resolve(legacyCopy(text));
}

function flashCopiedLabel(btn) {
	if (!btn || btn.dataset.copyFlash === "true") return;

	const original = btn.textContent;
	btn.dataset.copyFlash = "true";
	btn.classList.add("is-copied");
	btn.textContent = "Copied!";
	setTimeout(() => {
		btn.textContent = original;
		btn.classList.remove("is-copied");
		delete btn.dataset.copyFlash;
	}, 2000);
}

/**
 * Initialize benefit view tracking with Intersection Observer
 */
function initBenefitViewTracking(config) {
	const viewedBenefits = new Map(); // Track benefit visibility state
	const sentBenefitIds = new Set(); // Benefits that have already been sent (permanent record)
	let pendingBenefitIds = new Set(); // Benefits ready to be sent in next batch

	const observer = new IntersectionObserver(
		(entries) => {
			const currentTime = Date.now();

			entries.forEach((entry) => {
				const benefitId = entry.target.getAttribute("data-benefit-id");
				if (!benefitId || sentBenefitIds.has(benefitId)) return; // Skip if already tracked

				if (entry.isIntersecting) {
					// Benefit entered viewport
					if (!viewedBenefits.has(benefitId)) {
						viewedBenefits.set(benefitId, {
							firstSeenAt: currentTime,
							isVisible: true,
							timeout: null,
							checkTimeout: null,
						});

						// Start timing: wait 1 second, then check if still visible for 0.5s more
						const benefitData = viewedBenefits.get(benefitId);
						benefitData.timeout = setTimeout(() => {
							// After 1 second, check if still visible
							if (benefitData.isVisible) {
								benefitData.checkTimeout = setTimeout(() => {
									// After 0.5s more (1.5s total), verify still visible
									if (benefitData.isVisible && !sentBenefitIds.has(benefitId)) {
										pendingBenefitIds.add(benefitId);
										sentBenefitIds.add(benefitId); // Mark as sent permanently
									}
								}, 500);
							}
						}, 1000);
					} else {
						// Update visibility state if benefit re-entered viewport
						viewedBenefits.get(benefitId).isVisible = true;
					}
				} else {
					// Benefit left viewport
					if (viewedBenefits.has(benefitId)) {
						const benefitData = viewedBenefits.get(benefitId);
						benefitData.isVisible = false;

						// Clear timers and remove from tracking
						if (benefitData.timeout) {
							clearTimeout(benefitData.timeout);
						}
						if (benefitData.checkTimeout) {
							clearTimeout(benefitData.checkTimeout);
						}
						viewedBenefits.delete(benefitId);
					}
				}
			});
		},
		{
			threshold: 0.5, // At least 50% of the element must be visible
			rootMargin: "0px",
		}
	);

	// Observe all benefit items
	const observeBenefits = () => {
		const benefitElements = document.querySelectorAll(
			".member-benefits-list__item"
		);
		benefitElements.forEach((element) => {
			observer.observe(element);
		});
	};

	// Initial observation
	observeBenefits();

	// Send batched metrics every 2 seconds (only benefits not yet sent)
	setInterval(() => {
		if (pendingBenefitIds.size > 0) {
			const benefitIdsArray = Array.from(pendingBenefitIds);
			recordBenefitMetric(config, benefitIdsArray, "benefit_view");
			pendingBenefitIds.clear(); // Clear pending batch
			// Note: sentBenefitIds remains unchanged to prevent re-sending
		}
	}, 2000);

	// Re-observe when benefits are updated
	const originalUpdateBenefitsDisplay = window.updateBenefitsDisplay;
	if (originalUpdateBenefitsDisplay) {
		window.updateBenefitsDisplay = function (...args) {
			originalUpdateBenefitsDisplay.apply(this, args);
			// Wait for DOM update
			setTimeout(() => {
				observer.disconnect();
				observeBenefits();
			}, 300);
		};
	}
}

/**
 * Display a temporary message to the user
 */
function showBenefitMessage(headline, subtext, type = "success") {
	// Remove any existing message
	const existingMessage = document.querySelector(".benefit-message");
	if (existingMessage) {
		existingMessage.remove();
	}

	// Create message element
	const messageDiv = document.createElement("div");
	messageDiv.className = `benefit-message benefit-message--${type}`;
	messageDiv.innerHTML = `
    <div class="benefit-message__content">
      <div class="benefit-message__headline">${headline}</div>
      <div class="benefit-message__subtext">${subtext}</div>
      <button class="benefit-message__close" aria-label="Close">&times;</button>
    </div>
  `;

	document.body.appendChild(messageDiv);

	messageDiv.style.display = "block";
	// Close button handler
	const closeBtn = messageDiv.querySelector(".benefit-message__close");
	const closeMessage = () => {
		messageDiv.style.opacity = "0";
		messageDiv.style.transition = "opacity 0.3s ease-out";
		setTimeout(() => messageDiv.remove(), 300);
	};

	closeBtn.addEventListener("click", closeMessage);

	// Auto-remove after 4 seconds
	setTimeout(closeMessage, 4000);
}

/**
 * Set up event listeners for benefit actions
 */
function setupBenefitEventListeners(config, memberInfo) {
	document.addEventListener("click", async function (e) {
		// Buttons nest a <span>, so resolve the control with closest().
		const actionBtn = e.target.closest(
			".btn--redeem, .btn--request, .btn--visit-partner, .btn--learn-more, .btn--copy-code"
		);
		if (!actionBtn) return;
		const target = actionBtn;

		// click metrics
		{
			const benefitId = target.getAttribute("data-benefit-id");
			if (benefitId) {
				recordBenefitMetric(config, [benefitId], "benefit_click");
			}

			if (!target.classList.contains("btn--visit-partner")) {
				e.preventDefault();
			}
		}

		// One-step redeem: when a code already exists the primary button copies it.
		// btn--redeem drives its own label ("REDEEMING…"), so it copies silently and
		// the re-rendered card confirms instead.
		const existingCode = target.getAttribute("data-code");
		if (existingCode) {
			const flashes =
				target.classList.contains("btn--visit-partner") ||
				target.classList.contains("btn--copy-code");
			copyBenefitCode(existingCode).then((copied) => {
				if (copied && flashes) flashCopiedLabel(target);
			});
		}

		// Handle request button clicks
		if (target.classList.contains("btn--request")) {
			e.preventDefault();
			const benefitId = target.getAttribute("data-benefit-id");
			if (benefitId && !target.disabled) {
				const originalText = target.textContent;
				target.textContent = "REQUESTING...";
				target.disabled = true;

				try {
					const requestResult = await requestBenefit(config, benefitId);

					if (requestResult && requestResult.success) {
						showBenefitMessage(
							"WE'VE RECORDED YOUR REQUEST",
							"You'll be notified if more codes become available.",
							"success"
						);
						target.textContent = "REQUESTED";
					}
				} catch (error) {
					console.error("Error requesting benefit:", error);
					showBenefitMessage(
						"REQUEST FAILED",
						"Failed to submit request. Please try again.",
						"error"
					);
					target.textContent = originalText;
					target.disabled = false;
				}
			}
		}

		// Handle redeem button clicks
		if (target.classList.contains("btn--redeem")) {
			e.preventDefault();
			const benefitId = target.getAttribute("data-benefit-id");
			const bundleBenefitId = target.getAttribute("data-bundle-id");
			const cardBenefitId = bundleBenefitId || benefitId;
			if (benefitId && !target.disabled) {
				const originalText = target.textContent;

				// Find current benefit state to check if code exists before redemption
				const currentBenefit = memberInfo.benefits.find(
					(b) => String(b.id) === String(cardBenefitId)
				);
				const currentEntry = currentBenefit
					? bundleEntries(currentBenefit).find(
							(entry) => String(entry.id) === String(benefitId)
						)
					: null;
				const hasCodeBefore =
					currentEntry && currentEntry.coupon && currentEntry.coupon.code;

				target.textContent = "REDEEMING...";
				target.disabled = true;

				try {
					const redeemBenefitResponse = await redeemBenefit(
						config,
						benefitId,
						memberInfo,
						cardBenefitId
					);

					if (
						redeemBenefitResponse &&
						redeemBenefitResponse.success === false
					) {
						// Handle consent denial
						if (redeemBenefitResponse.reason === "consent_denied") {
							target.textContent = originalText;
							target.disabled = false;
							return; // Don't record metric if consent was denied
						}
					}

					// If redemption was successful and we have updated benefit data
					if (
						redeemBenefitResponse &&
						redeemBenefitResponse.success &&
						redeemBenefitResponse.benefit
					) {
						let updatedBenefit;

						if (bundleBenefitId) {
							const refreshedMemberInfo = await fetchMemberInfo(config);
							if (refreshedMemberInfo && refreshedMemberInfo.benefits) {
								memberInfo.benefits = refreshedMemberInfo.benefits;
								updatedBenefit = memberInfo.benefits.find(
									(b) => String(b.id) === String(cardBenefitId)
								);
							}
						} else {
							const redeemedBenefit = redeemBenefitResponse.benefit;
							updatedBenefit = {
								...currentBenefit,
								...redeemedBenefit,
								partner: {
									...currentBenefit?.partner,
									...redeemedBenefit.partner,
								},
							};

							// Update memberInfo in place to reflect new state
							if (memberInfo && memberInfo.benefits) {
								const benefitIndex = memberInfo.benefits.findIndex(
									(b) => String(b.id) === String(cardBenefitId)
								);
								if (benefitIndex !== -1) {
									memberInfo.benefits[benefitIndex] = updatedBenefit;
								}
							}
						}

						// Find and replace the benefit card in the UI
						const benefitCard = document.querySelector(
							`.member-benefits-list__item[data-benefit-id="${cardBenefitId}"]`
						);
						if (updatedBenefit && benefitCard) {
							const keepsFocus = document.activeElement === target;
							const newBenefitCard = createBenefitElement(updatedBenefit);
							benefitCard.replaceWith(newBenefitCard);
							setBenefitExpanded(newBenefitCard, true);
							applyBenefitsPagination();

							if (keepsFocus) {
								const refocusTarget = [
									...newBenefitCard.querySelectorAll(
										".btn--redeem, .btn--request, .btn--visit-partner"
									),
								].find(
									(control) =>
										control.getAttribute("data-benefit-id") === String(benefitId)
								);
								if (refocusTarget) refocusTarget.focus();
							}

							const updatedEntry =
								bundleEntries(updatedBenefit).find(
									(entry) => String(entry.id) === String(benefitId)
								) || updatedBenefit;

							// Redemption just produced a code — copy it and confirm on the new button.
							const freshCode = updatedEntry.coupon && updatedEntry.coupon.code;
							if (freshCode) {
								const freshBtn =
									[...newBenefitCard.querySelectorAll("[data-code]")].find(
										(el) => el.getAttribute("data-code") === freshCode
									) || newBenefitCard.querySelector("[data-code]");
								copyBenefitCode(freshCode).then((copied) => {
									if (copied) flashCopiedLabel(freshBtn);
								});
							}

							// Popup vs Direct Redirect Logic
							const showPopup =
								!hasCodeBefore &&
								freshCode &&
								updatedEntry.coupon.auto_apply === false;

							if (showPopup) {
								// First time redeem (Individual code) -> Show Popup
								showRedeemPopup(freshCode, updatedEntry.url);
							} else if (updatedEntry.url) {
								// Already had code (Shared code or subsequent redeem) -> Direct Redirect
								window.open(updatedEntry.url, "_blank");
							}
						} else {
							const refreshedMemberInfo = await fetchMemberInfo(config);
							if (refreshedMemberInfo && refreshedMemberInfo.benefits) {
								memberInfo.benefits = refreshedMemberInfo.benefits;
								updateBenefitsDisplay(refreshedMemberInfo.benefits);
								updateMemberInfoDisplay(refreshedMemberInfo);
							}
							target.textContent = originalText;
							target.disabled = false;
						}
					} else {
						// Fallback: refresh entire benefits list
						const updatedMemberInfo = await fetchMemberInfo(config);
						updateBenefitsDisplay(updatedMemberInfo.benefits);
						updateMemberInfoDisplay(updatedMemberInfo);
					}
				} catch (error) {
					console.error("Error during benefit redemption:", error);
					showBenefitMessage(
						"REDEMPTION FAILED",
						"Failed to redeem benefit. Please try again.",
						"error"
					);
					target.textContent = originalText;
					target.disabled = false;
				}
			}
		}

		if (target.classList.contains("btn--learn-more")) {
			e.preventDefault();
			const card = target.closest(".member-benefits-list__item");
			if (card) {
				setBenefitExpanded(
					card,
					target.getAttribute("aria-expanded") !== "true"
				);
			}
		}
	});
}

function setBenefitExpanded(card, expanded) {
	if (!card) return;

	const detailsBtn = card.querySelector(".btn--learn-more");
	if (detailsBtn) {
		detailsBtn.setAttribute("aria-expanded", expanded ? "true" : "false");
		detailsBtn.classList.toggle("btn--learn-more--active", expanded);
	}

	card
		.querySelectorAll(".js-md-benefit-reveal")
		.forEach((reveal) => setRevealOpen(reveal, expanded));
}

/**
 * Fetch races from the API endpoint
 */
async function fetchRaces(config) {
	try {
		const response = await fetch(
			`${config.apiUrl}/members/races?signature=${config.signature}`,
			{
				method: "GET",
				headers: {
					Accept: "application/json",
					Authorization: `Bearer ${config.signature}`,
					"Content-Type": "application/json",
				},
			}
		);

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const races = await response.json();
		return races;
	} catch (error) {
		console.error("Error fetching races:", error);
		return [];
	}
}

/**
 * Load races into the select dropdown
 */
async function loadRacesIntoSelect(config) {
	const raceSelect = document.getElementById("race-modal__name");
	if (!raceSelect) return;

	try {
		const races = await fetchRaces(config);

		// Clear existing options except the first two (placeholder and custom)
		const placeholderOption = raceSelect.querySelector('option[value=""]');
		const customOption = raceSelect.querySelector('option[value="custom"]');
		raceSelect.innerHTML = "";

		// Re-add placeholder and custom options
		if (placeholderOption) raceSelect.appendChild(placeholderOption);
		if (customOption) raceSelect.appendChild(customOption);

		// Add races from API
		races.forEach((race) => {
			const option = document.createElement("option");
			option.value = race.handle;
			option.textContent = race.name;
			option.setAttribute("data-race-id", race.id);
			option.setAttribute(
				"data-race-distances",
				JSON.stringify(race.distances)
			);
			option.setAttribute("data-race-date", race.date || "");
			option.setAttribute("data-race-month", race.month || "");
			raceSelect.appendChild(option);
		});

		raceSelect.value = "";

		// Store race data for later use
		raceSelect.dataset.racesLoaded = "true";
	} catch (error) {
		console.error("Error loading races into select:", error);
	}
}

/**
 * Create a new race via API (POST /members/{member_id}/races)
 */
async function createRace(config, raceData) {
	try {
		const response = await fetch(
			`${config.apiUrl}/members/${config.memberId}/races?signature=${config.signature}`,
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					Authorization: `Bearer ${config.signature}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					name: raceData.name,
					date: raceData.date,
					distance: raceData.distance,
					estimated_time: raceData.estimated_time,
					custom: raceData.custom !== undefined ? raceData.custom : true,
				}),
			}
		);

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const result = await response.json();
		return result;
	} catch (error) {
		console.error("Error creating race:", error);
		throw error;
	}
}

/**
 * Update an existing race via API (PUT /members/{member_id}/races/{race_id})
 */
async function updateRace(config, raceId, raceData) {
	try {
		const response = await fetch(
			`${config.apiUrl}/members/${config.memberId}/races/${raceId}?signature=${config.signature}`,
			{
				method: "PUT",
				headers: {
					Accept: "application/json",
					Authorization: `Bearer ${config.signature}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify(raceData),
			}
		);

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const result = await response.json();
		return result;
	} catch (error) {
		console.error("Error updating race:", error);
		throw error;
	}
}

/**
 * Delete a race via API (DELETE /members/{member_id}/races/{race_id})
 */
async function deleteRace(config, raceId) {
	try {
		const response = await fetch(
			`${config.apiUrl}/members/${config.memberId}/races/${raceId}?signature=${config.signature}`,
			{
				method: "DELETE",
				headers: {
					Accept: "application/json",
					Authorization: `Bearer ${config.signature}`,
				},
			}
		);

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return { success: true };
	} catch (error) {
		console.error("Error deleting race:", error);
		throw error;
	}
}

/**
 * Show error message in race modal
 */
function showRaceModalError(message) {
	const raceModal = document.querySelector(".race-modal");
	if (!raceModal) return;

	// Remove existing error message if any
	let errorElement = raceModal.querySelector(".race-modal__error");
	if (!errorElement) {
		errorElement = document.createElement("div");
		errorElement.className = "race-modal__error";
		const modalBody = raceModal.querySelector(".race-modal__body");
		if (modalBody) {
			modalBody.insertBefore(errorElement, modalBody.firstChild);
		}
	}

	errorElement.textContent = message;
	errorElement.style.display = "block";

	// Scroll to top of modal to show error
	const modalContent = raceModal.querySelector(".race-modal__content");
	if (modalContent) {
		modalContent.scrollTop = 0;
	}
}

/**
 * Hide error message in race modal
 */
function hideRaceModalError() {
	const errorElement = document.querySelector(".race-modal__error");
	if (errorElement) {
		errorElement.style.display = "none";
	}
	clearRaceFieldErrors();
}

function clearRaceFieldErrors() {
	document.querySelectorAll(".race-modal__field-error").forEach((el) => {
		el.hidden = true;
		el.textContent = "";
	});
	document
		.querySelectorAll(".race-modal .field.has-error")
		.forEach((el) => el.classList.remove("has-error"));
	document
		.querySelectorAll(".race-modal [aria-invalid='true']")
		.forEach((el) => el.removeAttribute("aria-invalid"));
}

function showRaceFieldError(fieldId, message) {
	const input = document.getElementById(fieldId);
	if (!input) return;

	input.setAttribute("aria-invalid", "true");
	input.closest(".field")?.classList.add("has-error");

	const errorEl = document.querySelector(
		`.race-modal__field-error[data-error-for="${fieldId}"]`
	);
	if (errorEl) {
		errorEl.textContent = message;
		errorEl.hidden = false;
	}
}

function validateRaceFields(fields) {
	let valid = true;
	fields.forEach(([fieldId, label]) => {
		const input = document.getElementById(fieldId);
		const value = input ? String(input.value || "").trim() : "";
		if (!value) {
			showRaceFieldError(fieldId, `${label} is required.`);
			valid = false;
		}
	});
	return valid;
}

function goalTimeMask() {
	let goalTimeEls = document.querySelectorAll(
		"#race-modal__estimated-finish-time-custom, #race-modal__estimated-finish-time-prefilled"
	);
	goalTimeEls.forEach((goalTimeEl) => {
		goalTimeEl.setAttribute("placeholder", "HH:MM:SS");

		// Track whether the next digit is the first or second in a segment
		let isFirstDigit = true;

		// Intercept keydown to handle segment-based editing
		goalTimeEl.addEventListener("keydown", function (e) {
			const el = e.target;
			const key = e.key;

			// Allow Tab, Escape, etc.
			if (
				key === "Tab" ||
				key === "Escape" ||
				key === "Backspace" ||
				key === "Delete"
			) {
				if (key === "Backspace" || key === "Delete") {
					e.preventDefault();
					// Clear the current segment to "00"
					const parts = (el.value || "00:00:00").split(":");
					while (parts.length < 3) parts.push("00");
					const pos = el.selectionStart;
					const segIdx = pos < 3 ? 0 : pos < 6 ? 1 : 2;
					parts[segIdx] = "00";
					el.value = parts.join(":");
					const start = segIdx * 3;
					el.setSelectionRange(start, start + 2);
					isFirstDigit = true;
				}
				return;
			}

			// Arrow left/right to navigate segments
			if (key === "ArrowLeft" || key === "ArrowRight") {
				e.preventDefault();
				const pos = el.selectionStart;
				const segIdx = pos < 3 ? 0 : pos < 6 ? 1 : 2;
				let newSeg =
					key === "ArrowLeft"
						? Math.max(0, segIdx - 1)
						: Math.min(2, segIdx + 1);
				const start = newSeg * 3;
				el.setSelectionRange(start, start + 2);
				isFirstDigit = true;
				return;
			}

			// Arrow up/down to increment/decrement
			if (key === "ArrowUp" || key === "ArrowDown") {
				e.preventDefault();
				const parts = (el.value || "00:00:00").split(":");
				while (parts.length < 3) parts.push("00");
				const pos = el.selectionStart;
				const segIdx = pos < 3 ? 0 : pos < 6 ? 1 : 2;
				const maxVal = segIdx === 0 ? 99 : 59;
				let num = parseInt(parts[segIdx]) || 0;
				num =
					key === "ArrowUp" ? Math.min(num + 1, maxVal) : Math.max(num - 1, 0);
				parts[segIdx] = String(num).padStart(2, "0");
				el.value = parts.join(":");
				const start = segIdx * 3;
				el.setSelectionRange(start, start + 2);
				return;
			}

			// Only allow digit input
			if (!/^\d$/.test(key)) {
				e.preventDefault();
				return;
			}

			e.preventDefault();

			// Ensure we have a full HH:MM:SS value to work with
			const parts = (el.value || "00:00:00").split(":");
			while (parts.length < 3) parts.push("00");
			const pos = el.selectionStart;
			const segIdx = pos < 3 ? 0 : pos < 6 ? 1 : 2;
			const maxVal = segIdx === 0 ? 99 : 59;

			if (isFirstDigit) {
				// First digit: set segment to "0" + key
				parts[segIdx] = "0" + key;
				el.value = parts.join(":");
				// Stay on same segment, wait for second digit
				const start = segIdx * 3;
				el.setSelectionRange(start, start + 2);
				isFirstDigit = false;
			} else {
				// Second digit: combine with first digit
				const currentDigits = parts[segIdx].padStart(2, "0");
				let newVal = currentDigits[1] + key;
				let num = parseInt(newVal);
				if (num > maxVal) {
					newVal = "0" + key;
				}
				parts[segIdx] = newVal;
				el.value = parts.join(":");
				// Auto-advance to next segment
				const nextSeg = Math.min(segIdx + 1, 2);
				const start = nextSeg * 3;
				el.setSelectionRange(start, start + 2);
				isFirstDigit = true;
			}
		});

		// Still format on normal input as fallback (e.g. autofill)
		goalTimeEl.addEventListener("input", function (e) {
			let value = e.target.value.replace(/\D/g, "").substring(0, 6);
			if (value.length === 0) return;
			value = value.padEnd(6, "0");
			let hh = String(Math.min(parseInt(value.substring(0, 2)), 99)).padStart(
				2,
				"0"
			);
			let mm = String(Math.min(parseInt(value.substring(2, 4)), 59)).padStart(
				2,
				"0"
			);
			let ss = String(Math.min(parseInt(value.substring(4, 6)), 59)).padStart(
				2,
				"0"
			);
			e.target.value = `${hh}:${mm}:${ss}`;
		});

		// Select the HH, MM, or SS segment on click
		function selectSegment(el) {
			const pos = el.selectionStart;
			// HH:MM:SS -> segments at 0-2, 3-5, 6-8
			let start, end;
			if (pos < 3) {
				start = 0;
				end = 2;
			} else if (pos < 6) {
				start = 3;
				end = 5;
			} else {
				start = 6;
				end = 8;
			}
			// Only select if the segment exists in the value
			if (start < el.value.length) {
				el.setSelectionRange(start, Math.min(end, el.value.length));
			}
		}

		goalTimeEl.addEventListener("click", function (e) {
			// Defer to allow browser to set cursor position first
			isFirstDigit = true;
			requestAnimationFrame(() => selectSegment(e.target));
		});

		goalTimeEl.addEventListener("focus", function (e) {
			// Select the first segment (HH) on focus
			isFirstDigit = true;
			requestAnimationFrame(() => {
				if (e.target.value.length >= 2) {
					e.target.setSelectionRange(0, 2);
				}
			});
		});

		goalTimeEl.addEventListener("blur", function (e) {
			let value = e.target.value.replace(/\D/g, "");
			if (value.length > 0) {
				// Pad with zeros to 6 digits (00:00:00)
				value = value.padEnd(6, "0");

				let hh = String(Math.min(parseInt(value.substring(0, 2)), 99)).padStart(
					2,
					"0"
				);
				let mm = String(Math.min(parseInt(value.substring(2, 4)), 59)).padStart(
					2,
					"0"
				);
				let ss = String(Math.min(parseInt(value.substring(4, 6)), 59)).padStart(
					2,
					"0"
				);

				e.target.value = `${hh}:${mm}:${ss}`;
			}
		});
	});
}

goalTimeMask();

/**
 * Initialize race form submission handler
 */
function initRaceFormSubmission() {
	const raceForm = document.querySelector(".race-modal form");
	if (!raceForm) return;

	raceForm.addEventListener("submit", async (e) => {
		e.preventDefault();

		// Clear any previous error messages
		hideRaceModalError();

		const dashboardContainer = document.querySelector(".membership-dashboard");
		if (!dashboardContainer) return;

		const config = {
			apiUrl: dashboardContainer.getAttribute("data-api-url"),
			memberId: dashboardContainer.getAttribute("data-member-id"),
			signature: dashboardContainer.getAttribute("data-signature"),
		};

		const raceSelect = document.getElementById("race-modal__name");
		const selectedRace = raceSelect.value;
		const raceModal = document.querySelector(".race-modal");
		const isEditMode = raceModal.getAttribute("data-mode") === "edit";

		// Check which form section is active
		const customRaceSection = document.querySelector(".race-custom");
		const prefilledRaceSection = document.querySelector(".race-prefilled");
		const isCustomFormActive = customRaceSection.classList.contains("active");
		const isPrefilledFormActive =
			prefilledRaceSection.classList.contains("active");

		let raceData = null;
		let isValid = false;

		// Determine which form is active and collect data
		if (selectedRace === "custom" || (isEditMode && isCustomFormActive)) {
			// Custom race form
			const name = document
				.getElementById("race-modal__name-custom")
				.value.trim();
			const distance = document
				.getElementById("race-modal__distance-custom")
				.value.trim();
			const date = document.getElementById("race-modal__date-custom").value;
			const estimatedTime = document
				.getElementById("race-modal__estimated-finish-time-custom")
				.value.trim();

			// Validate all fields are filled
			const customFieldsValid = validateRaceFields([
				["race-modal__name-custom", "Race name"],
				["race-modal__distance-custom", "Distance"],
				["race-modal__date-custom", "Race date"],
				["race-modal__estimated-finish-time-custom", "Goal time"],
			]);

			if (customFieldsValid) {
				// Duration input returns HH:MM:SS format via goalTimeMask
				// No additional time format validation needed

				// Validate year is not too far in the future (max 10 years from now)
				const raceDate = new Date(date);
				const currentYear = new Date().getFullYear();
				const raceYear = raceDate.getFullYear();
				const maxYear = currentYear + 10;

				if (raceYear > maxYear) {
					showRaceFieldError(
						"race-modal__date-custom",
						`Race year cannot be more than ${maxYear}.`
					);
					return;
				}

				isValid = true;
				raceData = {
					name: name,
					distance: distance,
					date: date,
					estimated_time: estimatedTime,
				};
			} else {
				return;
			}
		} else if (
			(selectedRace && selectedRace !== "") ||
			(isEditMode && isPrefilledFormActive)
		) {
			// Prefilled race form (catalog race or edit mode)
			let name = "";
			if (isEditMode) {
				// In edit mode, get name from the distance select option or input
				const distanceSelect = document.getElementById(
					"race-modal__distance-prefilled"
				);
				name = distanceSelect.options[0]?.textContent || "Race";
			} else {
				const selectedOption = raceSelect.options[raceSelect.selectedIndex];
				name = selectedOption.textContent;
			}

			const distance = document.getElementById(
				"race-modal__distance-prefilled"
			).value;
			const dateInput = document.getElementById("race-modal__date-prefilled");
			const dateValue = dateInput.value;
			const estimatedTime = document
				.getElementById("race-modal__estimated-finish-time-prefilled")
				.value.trim();

			// Validate all fields are filled
			const prefilledFieldsValid = validateRaceFields([
				["race-modal__distance-prefilled", "Distance"],
				["race-modal__date-prefilled", "Race date"],
				["race-modal__estimated-finish-time-prefilled", "Goal time"],
			]);

			if (prefilledFieldsValid) {
				// Duration input returns HH:MM:SS format via goalTimeMask
				// No additional validation needed as the mask enforces the format

				isValid = true;
				raceData = {
					name: name,
					distance: distance,
					estimated_time: estimatedTime,
				};

				raceData.date = dateValue;
			} else {
				return;
			}
		} else {
			showRaceFieldError("race-modal__name", "Please select a race.");
			return;
		}

		if (isValid && raceData) {
			const submitBtn = raceForm.querySelector('button[type="submit"]');
			const originalText = submitBtn.textContent;
			submitBtn.textContent = "Saving...";
			submitBtn.disabled = true;

			// Check if we're in edit mode
			const raceModal = document.querySelector(".race-modal");
			const isEditMode = raceModal.getAttribute("data-mode") === "edit";
			const raceId = document.getElementById("race-modal__id")?.value;
			const isCustomRace =
				document.getElementById("race-modal__custom")?.value === "true";

			try {
				if (isEditMode && raceId) {
					// Update existing race
					if (!isCustomRace) {
						// For catalog races, send distance, date, and estimated_time
						await updateRace(config, raceId, {
							distance: raceData.distance,
							date: raceData.date,
							estimated_time: raceData.estimated_time,
						});
					} else {
						// For custom races, send all editable fields
						await updateRace(config, raceId, {
							name: raceData.name,
							distance: raceData.distance,
							date: raceData.date,
							estimated_time: raceData.estimated_time,
						});
					}
				} else {
					// Create new race
					raceData.custom = selectedRace === "custom";
					await createRace(config, raceData);
				}

				// Success - close modal and reset form
				raceModal.classList.remove("race-modal--active");
				raceForm.reset();
				resetRaceModalToAddMode();

				// Reload page to show updated races from metafield
				// This ensures we get the latest data from Shopify
				window.location.reload();
			} catch (error) {
				showRaceModalError(
					isEditMode
						? "Failed to update race. Please try again."
						: "Failed to save race. Please try again."
				);
			} finally {
				submitBtn.textContent = originalText;
				submitBtn.disabled = false;
			}
		}
	});
}

// Initialize race form functionality
function initRaceForm() {
	// Race data will be loaded from API when modal opens

	const raceSelect = document.getElementById("race-modal__name");
	const customRaceSection = document.querySelector(".race-custom");
	const prefilledRaceSection = document.querySelector(".race-prefilled");

	if (!raceSelect || !customRaceSection || !prefilledRaceSection) return;

	// Handle race selection change
	raceSelect.addEventListener("change", function () {
		const selectedRace = this.value;

		// Clear error message when selection changes
		hideRaceModalError();

		if (selectedRace === "" || !selectedRace) {
			// Hide both sections if no selection
			customRaceSection.classList.remove("active");
			prefilledRaceSection.classList.remove("active");

			// Disable validation for both forms
			disableFormValidation(customRaceSection);
			disableFormValidation(prefilledRaceSection);
		} else if (selectedRace === "custom") {
			// Show custom race form
			customRaceSection.classList.add("active");
			prefilledRaceSection.classList.remove("active");

			// Enable validation for custom, disable for prefilled
			enableFormValidation(customRaceSection);
			disableFormValidation(prefilledRaceSection);

			// Set minimum and maximum date constraints
			const customDateInput = document.getElementById(
				"race-modal__date-custom"
			);
			if (customDateInput) {
				const currentYear = new Date().getFullYear();
				const maxYear = currentYear + 10;
				customDateInput.removeAttribute("min");
				customDateInput.setAttribute("max", `${maxYear}-12-31`);
			}

			// Clear custom form fields
			clearFormFields(customRaceSection);
		} else {
			// Show prefilled race form with data from API
			customRaceSection.classList.remove("active");
			prefilledRaceSection.classList.add("active");

			// Enable validation for prefilled, disable for custom
			enableFormValidation(prefilledRaceSection);
			disableFormValidation(customRaceSection);

			// Get race data from selected option
			const selectedOption = this.options[this.selectedIndex];
			const raceInfo = {
				name: selectedOption.textContent,
				date: selectedOption.getAttribute("data-race-date"),
				month: selectedOption.getAttribute("data-race-month"),
				distances: JSON.parse(
					selectedOption.getAttribute("data-race-distances")
				),
				id: selectedOption.getAttribute("data-race-id"),
			};

			// Populate prefilled form with race data
			populatePrefilledFormFromAPI(raceInfo);
		}
	});

	// Initialize with no form visible and validation disabled
	customRaceSection.classList.remove("active");
	prefilledRaceSection.classList.remove("active");
	disableFormValidation(customRaceSection);
	disableFormValidation(prefilledRaceSection);
}

function enableFormValidation(container) {
	const inputs = container.querySelectorAll("input, select");
	inputs.forEach((input) => {
		input.setAttribute("required", "required");
	});
}

function disableFormValidation(container) {
	const inputs = container.querySelectorAll("input, select");
	inputs.forEach((input) => {
		input.removeAttribute("required");
	});
}

function clearFormFields(container) {
	const inputs = container.querySelectorAll("input, select");
	inputs.forEach((input) => {
		if (input.type === "date" || input.type === "text") {
			input.value = "";
		} else if (input.tagName === "SELECT") {
			input.selectedIndex = 0;
		}
	});
}

function populatePrefilledFormFromAPI(raceInfo) {
	if (!raceInfo) return;

	const prefilledSection = document.querySelector(".race-prefilled");

	// Update distance select - add all available distances from the race
	const distanceSelect = prefilledSection.querySelector(
		"#race-modal__distance-prefilled"
	);
	if (
		distanceSelect &&
		raceInfo.distances &&
		Array.isArray(raceInfo.distances)
	) {
		// Clear existing options
		distanceSelect.innerHTML = "";

		// Add placeholder option
		const placeholderOption = document.createElement("option");
		placeholderOption.value = "";
		placeholderOption.textContent = "Select Distance";
		placeholderOption.disabled = true;
		placeholderOption.selected = true;
		distanceSelect.appendChild(placeholderOption);

		// Add all distance options from the race
		raceInfo.distances.forEach((distance) => {
			const option = document.createElement("option");
			option.value = distance;
			option.textContent = distance;
			distanceSelect.appendChild(option);
		});
	}

	// Update date input
	const dateInput = prefilledSection.querySelector(
		"#race-modal__date-prefilled"
	);
	if (dateInput) {
		if (raceInfo.date) {
			// If we have an exact date, use it
			dateInput.type = "date";
			dateInput.value = raceInfo.date;
			dateInput.setAttribute("readonly", "readonly");
		} else if (raceInfo.month) {
			// If we only have a month, display it as text
			dateInput.type = "month";
			dateInput.value = raceInfo.month;
			dateInput.setAttribute("readonly", "readonly");
		} else {
			dateInput.type = "date";
			dateInput.value = "";
			dateInput.setAttribute("readonly", "readonly");
		}
	}

	// Clear estimated time input (user will fill this in)
	const timeInput = prefilledSection.querySelector(
		"#race-modal__estimated-finish-time-prefilled"
	);
	if (timeInput) {
		timeInput.value = "";
	}
}

/**
 * Render customer races from metafield
 */
function renderCustomerRaces() {
	const racesListContainer = document.querySelector(".races-list");
	if (!racesListContainer) return;

	try {
		const customerRacesScript = document.getElementById("customer-races");

		// If no script tag found, show empty state
		if (!customerRacesScript) {
			return; // Empty state is already in HTML
		}

		const racesData = customerRacesScript.textContent.trim();

		// If no data or empty, show empty state
		if (!racesData || racesData === "null" || racesData === "[]") {
			return; // Empty state is already in HTML
		}

		const races = JSON.parse(racesData);

		if (!Array.isArray(races) || races.length === 0) {
			return; // Keep empty state
		}

		// Sort races: future races ascending (soonest first), then past races descending (most recent first)
		const sortedRaces = sortRaces(races);

		// Clear container and render races
		racesListContainer.innerHTML = "";

		sortedRaces.forEach((race, index) => {
			const raceElement = createRaceElement(race);
			// Hide races after the 9th one (index 9 and beyond)
			if (index >= 9) {
				raceElement.classList.add("race-list__item--hidden");
			}
			racesListContainer.appendChild(raceElement);
		});

		// Initialize View More button functionality
		initViewMoreRaces(sortedRaces.length);
	} catch (error) {
		console.error("Error rendering customer races:", error);
	}
}

/**
 * Initialize View More/Hide button functionality for races
 */
function initViewMoreRaces(totalRaces) {
	const viewMoreBtn = document.querySelector(".btn--view-more-races");
	if (!viewMoreBtn) return;

	// Only show the button if there are more than 9 races
	if (totalRaces > 9) {
		viewMoreBtn.style.display = "block";
	} else {
		viewMoreBtn.style.display = "none";
		return;
	}

	// Remove any existing event listeners by cloning the button
	const newBtn = viewMoreBtn.cloneNode(true);
	viewMoreBtn.parentNode.replaceChild(newBtn, viewMoreBtn);

	// Add click event listener
	newBtn.addEventListener("click", function () {
		const hiddenRaces = document.querySelectorAll(".race-list__item--hidden");
		const isExpanded = hiddenRaces.length === 0;

		if (isExpanded) {
			// Hide races (show only first 9)
			const allRaces = document.querySelectorAll(".race-list__item");
			allRaces.forEach((race, index) => {
				if (index >= 9) {
					race.classList.add("race-list__item--hidden");
				}
			});
			newBtn.textContent = "VIEW MORE ↓";
		} else {
			// Show all races
			hiddenRaces.forEach((race) => {
				race.classList.remove("race-list__item--hidden");
			});
			newBtn.textContent = "HIDE ↑";
		}
	});
}

/**
 * Sort races: future races ascending (soonest first), then past races descending (most recent first)
 */
function sortRaces(races) {
	if (!Array.isArray(races)) return races;

	const today = new Date();
	today.setHours(0, 0, 0, 0);

	return [...races].sort((a, b) => {
		const dateA = a.date ? new Date(a.date) : null;
		const dateB = b.date ? new Date(b.date) : null;

		// Handle races without dates - put them at the end
		if (!dateA && !dateB) return 0;
		if (!dateA) return 1;
		if (!dateB) return -1;

		const isPastA = dateA < today;
		const isPastB = dateB < today;

		// Both future: sort ascending (soonest first)
		if (!isPastA && !isPastB) {
			return dateA - dateB;
		}

		// Both past: sort descending (most recent first)
		if (isPastA && isPastB) {
			return dateB - dateA;
		}

		// One future, one past: future comes first
		return isPastA ? 1 : -1;
	});
}

function computeRaceCountdown(dateValue) {
	const target = new Date(dateValue);
	if (isNaN(target.getTime())) {
		return {
			months: 0,
			weeks: 0,
			days: 0,
			hours: 0,
			isPast: false,
			isToday: false,
		};
	}

	const now = new Date();
	const diff = target.getTime() - now.getTime();

	if (diff <= 0) {
		const todayStart = new Date(
			now.getFullYear(),
			now.getMonth(),
			now.getDate()
		).getTime();
		const raceStart = new Date(
			target.getFullYear(),
			target.getMonth(),
			target.getDate()
		).getTime();
		const isToday = todayStart === raceStart;
		return {
			months: 0,
			weeks: 0,
			days: 0,
			hours: 0,
			isPast: !isToday,
			isToday,
		};
	}

	const day = 1000 * 60 * 60 * 24;
	const months = Math.floor(diff / (day * 30));
	const afterMonths = diff - months * day * 30;
	const weeks = Math.floor(afterMonths / (day * 7));
	const afterWeeks = afterMonths - weeks * day * 7;
	const days = Math.floor(afterWeeks / day);
	const hours = Math.floor(afterWeeks / (1000 * 60 * 60)) % 24;

	return { months, weeks, days, hours, isPast: false, isToday: false };
}

const RACE_COUNTDOWN_UNITS = [
	["months", "Months"],
	["weeks", "Weeks"],
	["days", "Days"],
	["hours", "Hours"],
];

function renderRaceCountdown(card) {
	const region = card.querySelector(".js-md-race-countdown");
	if (!region) return;

	const dateValue = region.getAttribute("data-date");
	if (!dateValue || dateValue === "null") return;

	const cd = computeRaceCountdown(dateValue);

	card.classList.toggle("md-race--past", cd.isPast);

	if (cd.isToday) {
		region.className = "md-race__state js-md-race-countdown";
		region.textContent = "Race Day! 🏃";
		return;
	}

	if (cd.isPast) {
		region.className =
			"md-race__state md-race__state--completed js-md-race-countdown";
		region.textContent = "Race completed";
		return;
	}

	region.className = "md-race__countdown js-md-race-countdown";
	const nextMarkup = RACE_COUNTDOWN_UNITS.map(
		([key, label]) => `
			<div class="md-race__cd-cell">
				<span class="md-race__cd-value">${cd[key]}</span>
				<span class="md-race__cd-label">${label}</span>
			</div>`
	).join("");

	if (region.dataset.rendered !== nextMarkup) {
		region.innerHTML = nextMarkup;
		region.dataset.rendered = nextMarkup;
	}
}

let raceCountdownTimer = null;

function initRaceCountdownTicker() {
	const tick = () => {
		document
			.querySelectorAll(".md-race")
			.forEach((card) => renderRaceCountdown(card));
	};

	tick();
	if (raceCountdownTimer) clearInterval(raceCountdownTimer);
	raceCountdownTimer = setInterval(tick, 1000);
}

/**
 * Create a race element
 */
function createRaceElement(race) {
	const raceDiv = document.createElement("div");
	const isIncomplete = !race.estimated_time || !race.distance || !race.date;
	raceDiv.className =
		"race-list__item md-race" +
		(isIncomplete ? " race-list__item--incomplete" : "");
	raceDiv.setAttribute("data-race-id", race.id || "");
	raceDiv.setAttribute("data-race-custom", race.custom ? "true" : "false");

	// Store available distances for catalog races
	if (race.distances && Array.isArray(race.distances)) {
		raceDiv.setAttribute("data-race-distances", JSON.stringify(race.distances));
	}

	let formattedDate = "";
	let hasCountdown = false;

	if (race.date) {
		const raceDate = new Date(race.date);
		hasCountdown = true;

		const dateOptions = { year: "numeric", month: "long", day: "numeric" };
		const dateOptionsMonth = { year: "numeric", month: "long" };
		if (race.date.length === 10) {
			formattedDate = raceDate.toLocaleDateString("en-US", dateOptions);
		} else {
			formattedDate = raceDate.toLocaleDateString("en-US", dateOptionsMonth);
		}
	} else if (race.month) {
		// Format month for display (e.g., "2026-12" -> "December 2026")
		const [year, month] = race.month.split("-");
		const monthDate = new Date(parseInt(year), parseInt(month) - 1, 1);
		formattedDate = monthDate.toLocaleDateString("en-US", {
			year: "numeric",
			month: "long",
		});
	}

	// Check if race is in the past
	const isPast = race.date
		? new Date(race.date) < new Date(new Date().setHours(0, 0, 0, 0))
		: false;

	if (isPast) raceDiv.classList.add("md-race--past");

	const actionsHtml = `
		<div class="md-race__actions race-list__item__actions">
			${
				!isPast
					? `<button type="button" class="race-list__item__action-btn race-list__item__edit-btn" aria-label="Edit race" data-race-id="${
							race.id || ""
						}">${editIcon}</button>`
					: ""
			}
			<button type="button" class="race-list__item__action-btn race-list__item__delete-btn" aria-label="Delete race" data-race-id="${
				race.id || ""
			}">${deleteIcon}</button>
		</div>
	`;

	raceDiv.innerHTML = `
		<span class="md-race__strip" aria-hidden="true"></span>
		<div class="md-race__head">
			<div class="md-race__titles">
				<p class="md-race__name">${race.name || ""}</p>
				<div class="md-race__date">${!isIncomplete ? checkIcon : ""}${formattedDate}</div>
				${race.distance ? `<div class="md-race__distance">${race.distance}</div>` : ""}
			</div>
			${actionsHtml}
		</div>
		<div class="md-race__countdown js-md-race-countdown" data-date="${
			hasCountdown ? race.date : ""
		}"></div>
		<div class="md-race__goal">
			<span class="md-race__goal-label">Goal time</span>
			<span class="md-race__goal-value">${race.estimated_time || "N/A"}</span>
		</div>
	`;

	if (hasCountdown) renderRaceCountdown(raceDiv);

	// Attach event listeners for edit and delete buttons
	const editBtn = raceDiv.querySelector(".race-list__item__edit-btn");
	const deleteBtn = raceDiv.querySelector(".race-list__item__delete-btn");

	if (editBtn) {
		editBtn.addEventListener("click", () => openEditRaceModal(race));
	}

	if (deleteBtn) {
		deleteBtn.addEventListener("click", () => handleDeleteRace(race));
	}

	return raceDiv;
}

/**
 * Get race configuration from JSON script
 */
function getRaceConfig() {
	const raceConfigScript = document.getElementById("race-config");
	let config = {
		deleteConfirmationEnabled: true,
		deleteConfirmationMessage:
			"<p>This will delete the race from your saved list. Do you want to delete?</p>",
	};

	if (raceConfigScript) {
		try {
			const configData = JSON.parse(raceConfigScript.textContent);
			config = { ...config, ...configData };
		} catch {
			console.warn("Could not parse race config JSON");
		}
	}

	return config;
}

/**
 * Open the race modal in edit mode with prefilled data
 */
function openEditRaceModal(race) {
	const raceModal = document.querySelector(".race-modal");
	if (!raceModal) return;

	// Set modal to edit mode
	raceModal.setAttribute("data-mode", "edit");

	// Update modal title and button text
	const modalTitle = raceModal.querySelector(".race-modal__title");
	const submitBtn = raceModal.querySelector(".race-modal__submit-btn");
	if (modalTitle) modalTitle.textContent = "EDIT RACE";
	if (submitBtn) submitBtn.textContent = "Save";

	// Store race data in hidden fields
	const raceIdInput = document.getElementById("race-modal__id");
	const raceCustomInput = document.getElementById("race-modal__custom");
	if (raceIdInput) raceIdInput.value = race.id || "";
	if (raceCustomInput) raceCustomInput.value = race.custom ? "true" : "false";

	const raceSelect = document.getElementById("race-modal__name");
	const customRaceSection = document.querySelector(".race-custom");
	const prefilledRaceSection = document.querySelector(".race-prefilled");

	// Determine if this is a custom race or catalog race
	const isCustomRace = race.custom === true;

	if (isCustomRace) {
		// Show custom race form with prefilled data
		raceSelect.value = "custom";
		customRaceSection.classList.add("active");
		prefilledRaceSection.classList.remove("active");

		// Enable validation for custom form
		enableFormValidation(customRaceSection);
		disableFormValidation(prefilledRaceSection);

		// Prefill custom form fields - all fields are editable for custom races
		const nameInput = document.getElementById("race-modal__name-custom");
		const distanceInput = document.getElementById(
			"race-modal__distance-custom"
		);
		const dateInput = document.getElementById("race-modal__date-custom");
		const timeInput = document.getElementById(
			"race-modal__estimated-finish-time-custom"
		);

		// Ensure all fields are editable (remove any readonly/disabled attributes)
		if (nameInput) {
			nameInput.value = race.name || "";
			nameInput.removeAttribute("readonly");
			nameInput.removeAttribute("disabled");
		}
		if (distanceInput) {
			distanceInput.value = race.distance || "";
			distanceInput.removeAttribute("readonly");
			distanceInput.removeAttribute("disabled");
		}
		if (dateInput) {
			dateInput.value = race.date || "";
			dateInput.removeAttribute("readonly");
			dateInput.removeAttribute("disabled");
		}
		if (timeInput) {
			timeInput.value = race.estimated_time || "";
			timeInput.removeAttribute("readonly");
			timeInput.removeAttribute("disabled");
		}
	} else {
		// Catalog race - show prefilled form with editable fields
		// For catalog races: distance, date, and estimated_time are editable
		// Set the race name in the select (if it exists as an option)
		const raceName = race.name || "";
		let raceFound = false;

		// Try to find and select the race by name in the dropdown
		for (let i = 0; i < raceSelect.options.length; i++) {
			const option = raceSelect.options[i];
			if (option.textContent.trim() === raceName) {
				raceSelect.value = option.value;
				raceFound = true;
				break;
			}
		}

		// If race not found in dropdown, add it as an option and select it
		if (!raceFound && raceName) {
			const newOption = document.createElement("option");
			newOption.value = raceName.toLowerCase().replace(/\s+/g, "-");
			newOption.textContent = raceName;
			newOption.selected = true;
			raceSelect.appendChild(newOption);
		}

		customRaceSection.classList.remove("active");
		prefilledRaceSection.classList.add("active");

		// Disable race select in edit mode (can't change race name)
		raceSelect.disabled = true;

		// Enable validation for prefilled form
		enableFormValidation(prefilledRaceSection);
		disableFormValidation(customRaceSection);

		// Prefill prefilled form fields - distance is now editable
		const distanceSelect = document.getElementById(
			"race-modal__distance-prefilled"
		);
		const dateInput = document.getElementById("race-modal__date-prefilled");
		const timeInput = document.getElementById(
			"race-modal__estimated-finish-time-prefilled"
		);

		if (distanceSelect) {
			// Clear existing options
			distanceSelect.innerHTML = "";

			// Get available distances from race data
			let distances = [];
			if (race.distances && Array.isArray(race.distances)) {
				// Use predefined distances from the race
				distances = race.distances;
			} else {
				// Fallback to common distance options if not provided
				distances = [
					"5K",
					"10K",
					"Half Marathon",
					"Marathon",
					"50K",
					"50 Miles",
					"100K",
					"100 Miles",
				];
			}

			// Add current distance if not in the list
			const currentDistance = race.distance || "";
			if (currentDistance && !distances.includes(currentDistance)) {
				distances.unshift(currentDistance);
			}

			// Populate distance options
			distances.forEach((dist) => {
				const option = document.createElement("option");
				option.value = dist;
				option.textContent = dist;
				if (dist === currentDistance) {
					option.selected = true;
				}
				distanceSelect.appendChild(option);
			});

			// For catalog races, distance is not editable - only estimated time
			distanceSelect.setAttribute("readonly", "readonly");
			distanceSelect.setAttribute("disabled", "disabled");
		}

		if (dateInput) {
			// Format date properly for input[type="date"] (YYYY-MM-DD)
			let formattedDate = race.date || "";
			if (formattedDate) {
				// If date is already in YYYY-MM-DD format, use it
				// Otherwise try to parse and format it
				const dateMatch = formattedDate.match(/^\d{4}-\d{2}-\d{2}$/);
				if (!dateMatch) {
					const parsedDate = new Date(formattedDate);
					if (!isNaN(parsedDate.getTime())) {
						formattedDate = parsedDate.toISOString().split("T")[0];
					}
				}
			}
			dateInput.value = formattedDate;
			// For catalog races, race date is not editable
			dateInput.setAttribute("readonly", "readonly");
			dateInput.setAttribute("disabled", "disabled");
		}

		if (timeInput) {
			// Convert HH:MM:SS to HH:MM:SS format for input[type="time"]
			let formattedTime = race.estimated_time || "";
			if (formattedTime) {
				// Ensure format is HH:MM:SS
				const timeParts = formattedTime.split(":");
				if (timeParts.length === 3) {
					formattedTime = `${timeParts[0].padStart(
						2,
						"0"
					)}:${timeParts[1].padStart(2, "0")}:${timeParts[2].padStart(2, "0")}`;
				}
			}
			timeInput.value = formattedTime;
		}
	}

	// Hide race selector in edit mode (user can't change race type)
	const raceSelectField = raceSelect.closest(".field");
	if (raceSelectField) {
		raceSelectField.style.display = "none";
	}

	// Show the modal
	raceModal.classList.add("race-modal--active");
}

/**
 * Reset race modal to add mode
 */
function resetRaceModalToAddMode() {
	const raceModal = document.querySelector(".race-modal");
	if (!raceModal) return;

	// Reset modal to add mode
	raceModal.setAttribute("data-mode", "add");

	// Update modal title and button text
	const modalTitle = raceModal.querySelector(".race-modal__title");
	const submitBtn = raceModal.querySelector(".race-modal__submit-btn");
	if (modalTitle) modalTitle.textContent = "ADD RACE";
	if (submitBtn) submitBtn.textContent = "Add";

	// Clear hidden fields
	const raceIdInput = document.getElementById("race-modal__id");
	const raceCustomInput = document.getElementById("race-modal__custom");
	if (raceIdInput) raceIdInput.value = "";
	if (raceCustomInput) raceCustomInput.value = "";

	// Show and enable race selector
	const raceSelect = document.getElementById("race-modal__name");
	if (raceSelect) {
		raceSelect.disabled = false;
		raceSelect.value = "";
		const raceSelectField = raceSelect.closest(".field");
		if (raceSelectField) {
			raceSelectField.style.display = "";
		}
	}

	// Re-enable distance select for prefilled form
	const distanceSelect = document.getElementById(
		"race-modal__distance-prefilled"
	);
	if (distanceSelect) {
		distanceSelect.disabled = false;
	}

	// Hide both form sections
	const customRaceSection = document.querySelector(".race-custom");
	const prefilledRaceSection = document.querySelector(".race-prefilled");
	if (customRaceSection) customRaceSection.classList.remove("active");
	if (prefilledRaceSection) prefilledRaceSection.classList.remove("active");

	// Clear error messages
	hideRaceModalError();
}

/**
 * Handle delete race with optional confirmation
 */
async function handleDeleteRace(race) {
	const raceConfig = getRaceConfig();

	if (raceConfig.deleteConfirmationEnabled) {
		// Show confirmation dialog
		showDeleteConfirmationDialog(race, raceConfig.deleteConfirmationMessage);
	} else {
		// Delete immediately without confirmation
		await performDeleteRace(race);
	}
}

/**
 * Show delete confirmation dialog
 */
function showDeleteConfirmationDialog(race, message) {
	// Check if dialog already exists
	let dialog = document.getElementById("race-delete-dialog");

	if (!dialog) {
		// Create dialog HTML
		const dialogHTML = `
			<div id="race-delete-dialog" class="md-dialog" role="dialog" aria-modal="true" aria-labelledby="race-delete-dialog__title">
				<div class="md-dialog__content">
					<h4 class="md-dialog__title" id="race-delete-dialog__title">Delete Race?</h4>
					<div class="md-dialog__body">
						<p id="race-delete-dialog__name"></p>
						<div id="race-delete-dialog__message"></div>
					</div>
					<div class="md-dialog__actions">
						<button type="button" class="md-dialog__btn md-dialog__btn--cancel btn--delete-cancel">Cancel</button>
						<button type="button" class="md-dialog__btn md-dialog__btn--confirm btn--delete-confirm">Delete</button>
					</div>
				</div>
			</div>
		`;
		document.body.insertAdjacentHTML("beforeend", dialogHTML);
		dialog = document.getElementById("race-delete-dialog");
	}

	const nameEl = dialog.querySelector("#race-delete-dialog__name");
	if (nameEl) {
		const raceName = document.createElement("strong");
		raceName.textContent = race.name || "this race";
		nameEl.textContent = "Are you sure you want to delete ";
		nameEl.appendChild(raceName);
		nameEl.appendChild(document.createTextNode("?"));
	}

	// Set the confirmation message
	const messageEl = dialog.querySelector("#race-delete-dialog__message");
	if (messageEl) {
		messageEl.innerHTML = message;
	}

	// Show dialog
	dialog.classList.add("is-active");

	// Setup event handlers
	const confirmBtn = dialog.querySelector(".btn--delete-confirm");
	const cancelBtn = dialog.querySelector(".btn--delete-cancel");

	const closeDialog = () => {
		dialog.classList.remove("is-active");
		// Remove event listeners
		confirmBtn.removeEventListener("click", handleConfirm);
		cancelBtn.removeEventListener("click", closeDialog);
		dialog.removeEventListener("click", handleOverlayClick);
		document.removeEventListener("keydown", handleKeydown);
	};

	const handleKeydown = (e) => {
		if (e.key === "Escape") closeDialog();
	};

	const handleConfirm = async () => {
		closeDialog();
		await performDeleteRace(race);
	};

	const handleOverlayClick = (e) => {
		if (e.target === dialog) {
			closeDialog();
		}
	};

	confirmBtn.addEventListener("click", handleConfirm);
	cancelBtn.addEventListener("click", closeDialog);
	dialog.addEventListener("click", handleOverlayClick);
	document.addEventListener("keydown", handleKeydown);

	cancelBtn.focus();
}

/**
 * Perform the actual race deletion
 */
async function performDeleteRace(race) {
	const dashboardContainer = document.querySelector(".membership-dashboard");
	if (!dashboardContainer) return;

	const config = {
		apiUrl: dashboardContainer.getAttribute("data-api-url"),
		memberId: dashboardContainer.getAttribute("data-member-id"),
		signature: dashboardContainer.getAttribute("data-signature"),
	};

	try {
		await deleteRace(config, race.id);

		// Reload page to show updated races
		window.location.reload();
	} catch (error) {
		console.error("Failed to delete race:", error);
		alert("Failed to delete race. Please try again.");
	}
}

// Initialize tooltips for member savings icons
function initTooltips() {
	const tooltipContainers = document.querySelectorAll(".tooltip-container");

	tooltipContainers.forEach((container) => {
		const tooltipElement = container.querySelector(".tooltip");

		function showTooltip() {
			tooltipElement.style.opacity = "1";
			tooltipElement.style.visibility = "visible";
			tooltipElement.style.transform = "translateX(-70%) translateY(0)";
		}

		function hideTooltip() {
			tooltipElement.style.opacity = "0";
			tooltipElement.style.visibility = "hidden";
			tooltipElement.style.transform = "translateX(-70%) translateY(-5px)";
		}

		// Add hover event listeners for better accessibility
		container.addEventListener("mouseenter", () => {
			showTooltip();
		});

		container.addEventListener("mouseleave", () => {
			hideTooltip();
		});

		// Touch support for mobile devices
		container.addEventListener("touchstart", (e) => {
			e.preventDefault();
			showTooltip();

			// Hide tooltip after 3 seconds on touch
			setTimeout(() => {
				hideTooltip();
			}, 3000);
		});

		// Keyboard accessibility
		container.addEventListener("focus", () => {
			showTooltip();
		});

		container.addEventListener("blur", () => {
			hideTooltip();
		});
	});
}

// Export functions for external use if needed
window.MembershipDashboard = {
	fetchMemberInfo,
	redeemBenefit,
	requestBenefit,
	recordBenefitMetric,
};

/**
 * Initialize Redeem Modal
 */
function initRedeemModal() {
	const modalHTML = `
    <div id="redeem-modal" class="consent-modal consent-modal--redeem">
      <div class="consent-modal__content">
        <button type="button" class="consent-modal__close btn--close" id="redeem-modal-close" aria-label="Close modal">
          ${closeIcon}
        </button>
				<p class="t-b-3">Your Code</p>
        <div class="consent-modal__body">
           <p class="t-b-3">Use <span id="redeem-modal-code"></span> during checkout.</p>
        </div>
        <div class="consent-modal__actions">
          <a href="#" target="_blank" class="btn btn-small btn--primary" id="redeem-modal-btn">Go to partner store</a>
        </div>
      </div>
    </div>
  `;
	// Use a safer insertion method if possible, but insertAdjacentHTML is fine here
	const existingModal = document.getElementById("redeem-modal");
	if (!existingModal) {
		document.body.insertAdjacentHTML("beforeend", modalHTML);
	}

	// Close handlers
	const modal = document.getElementById("redeem-modal");
	if (modal) {
		const closeBtn = modal.querySelector("#redeem-modal-close");
		const close = () => modal.classList.remove("consent-modal--active");

		if (closeBtn) closeBtn.addEventListener("click", close);
		modal.addEventListener("click", (e) => {
			if (e.target === modal) close();
		});
	}
}

/**
 * Show Redeem Popup
 */
function codeWrapper(code) {
	return `<span style="padding: 0 4px; font-weight: bold">${code}</span>`;
}
function showRedeemPopup(code, url) {
	const modal = document.getElementById("redeem-modal");
	if (!modal) return;

	const codeEl = modal.querySelector("#redeem-modal-code");
	const btnEl = modal.querySelector("#redeem-modal-btn");

	if (codeEl)
		codeEl.innerHTML =
			typeof code === "string"
				? codeWrapper(code)
				: code.map((i) => codeWrapper(i)).join(" & ");
	if (btnEl) btnEl.href = url || "#";

	modal.classList.add("consent-modal--active");
}
